import { initSlide as bdtv_c33e4a0d2fca } from "@Bondit2Theme/mod-kotapa";
import {
  LazyLoadEventHover as bdtv_1f6648bfe1af,
  LazyLoader as bdtv_c18307a37828,
  loadImages as bdtv_a771d8d107da,
} from "@Bondit2Theme/mod-fipefi";
import { CustomElement as bdtv_bc7688b00aa5 } from "@Bondit2Theme/mod-ratamo";
import "@Bondit2Theme/mod-lugaso";
import "@Bondit2Theme/mod-lozani";
import * as bdtv_7d7dfa6f9df7 from "@Bondit2Theme/mod-fozane";
import { notifier as bdtv_86c1642f965f, notifierInline as bdtv_0b170d1f6e6b } from "@Bondit2Theme/mod-fumuse";
import { eventModal as bdtv_e7813df41f5c } from "@Bondit2Theme/mod-kodati";

bdtv_1f6648bfe1af.run();
new bdtv_c18307a37828(".bdt-figura-zora-no");
new bdtv_7d7dfa6f9df7.FSProgressBar("bdt-lolo-nopi-avanco-faixa2");

document.addEventListener("shopify:section:load", function () {
  new bdtv_c18307a37828(".bdt-figura-zora-no");
  new bdtv_7d7dfa6f9df7.FSProgressBar("bdt-lolo-nopi-avanco-faixa2");
});

try {
  document.querySelector(":focus-visible");
} catch (bdtv_93ae9c22b072) {
  bdtv_333f4b1d4e51();
}

function bdtv_54d0c7cbeb9e() {
  const { enable: bdtv_eb011f312907, firstNotification: bdtv_3ce871060bc5, secondaryNotification: bdtv_99c620092f55 } =
    window.flashingBrowseTab || {};
  const bdtv_89a017199cd2 = document.querySelector("title");
  if (!bdtv_eb011f312907 || !bdtv_89a017199cd2) return;
  const bdtv_b8d2603af64a = bdtv_89a017199cd2.innerText;
  let bdtv_765a491e52fb = true;
  let bdtv_03254585458c = null;

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      if (!bdtv_765a491e52fb) {
        clearInterval(bdtv_03254585458c);
        bdtv_89a017199cd2.innerText = bdtv_b8d2603af64a;
        bdtv_765a491e52fb = true;
      }
    } else {
      if (!bdtv_3ce871060bc5 || !bdtv_99c620092f55) return;
      bdtv_765a491e52fb = false;
      let bdtv_4e0a858d8e77 = true;
      bdtv_03254585458c = setInterval(() => {
        bdtv_89a017199cd2.innerText = bdtv_4e0a858d8e77 ? bdtv_3ce871060bc5 : bdtv_99c620092f55;
        bdtv_4e0a858d8e77 = !bdtv_4e0a858d8e77;
      }, 2000);
    }
  });
}
bdtv_54d0c7cbeb9e();

function bdtv_cde23807e73f() {
  requestAnimationFrame(() => {
    bdtv_7d7dfa6f9df7.getRoot().style.setProperty(
      "--bdt-scrollbar-width",
      bdtv_7d7dfa6f9df7.getScrollbarWidth() + "px"
    );
    window.addEventListener("resize", () => {
      bdtv_7d7dfa6f9df7.getRoot().style.setProperty(
        "--bdt-scrollbar-width",
        bdtv_7d7dfa6f9df7.getScrollbarWidth() + "px"
      );
    });
  });
}

bdtv_cde23807e73f();

function bdtv_333f4b1d4e51() {
  const bdtv_f377bf913808 = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let bdtv_0fb9f9de9d87 = null;
  let bdtv_e80cd0a27054 = null;

  window.addEventListener("keydown", (bdtv_34163c73b85e) => {
    if (bdtv_f377bf913808.includes(bdtv_34163c73b85e.code.toUpperCase())) {
      bdtv_e80cd0a27054 = false;
    }
  });

  window.addEventListener("mousedown", () => {
    bdtv_e80cd0a27054 = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (bdtv_0fb9f9de9d87)
        bdtv_0fb9f9de9d87.classList.remove("bdt-fotu");

      if (bdtv_e80cd0a27054) return;

      bdtv_0fb9f9de9d87 = document.activeElement;
      bdtv_0fb9f9de9d87.classList.add("bdt-fotu");
    },
    true
  );
}

var bdtv_db8d1ea790fe = bdtv_db8d1ea790fe || {};
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

bdtv_db8d1ea790fe.bind = function (bdtv_2935f7b3d292, bdtv_2ccb35bef650) {
  return function () {
    return bdtv_2935f7b3d292.apply(bdtv_2ccb35bef650, arguments);
  };
};

bdtv_db8d1ea790fe.setSelectorByValue = function (bdtv_ce5c8b322dbb, bdtv_c2ee6bd3dd33) {
  for (var bdtv_f9109af4fae1 = 0, bdtv_8333bdfb9842 = bdtv_ce5c8b322dbb.options.length; bdtv_f9109af4fae1 < bdtv_8333bdfb9842; bdtv_f9109af4fae1++) {
    var bdtv_de9ad9823bd1 = bdtv_ce5c8b322dbb.options[bdtv_f9109af4fae1];
    if (bdtv_c2ee6bd3dd33 == bdtv_de9ad9823bd1.value || bdtv_c2ee6bd3dd33 == bdtv_de9ad9823bd1.innerHTML) {
      bdtv_ce5c8b322dbb.selectedIndex = bdtv_f9109af4fae1;
      return bdtv_f9109af4fae1;
    }
  }
};

bdtv_db8d1ea790fe.addListener = function (bdtv_e90664ac5d6b, bdtv_0121ac2a154a, bdtv_669c4da1d52e) {
  bdtv_e90664ac5d6b.addEventListener
    ? bdtv_e90664ac5d6b.addEventListener(bdtv_0121ac2a154a, bdtv_669c4da1d52e, false)
    : bdtv_e90664ac5d6b.attachEvent("on" + bdtv_0121ac2a154a, bdtv_669c4da1d52e);
};

bdtv_db8d1ea790fe.postLink = function (bdtv_373240c522f1, bdtv_d14d1f2e2ba5) {
  bdtv_d14d1f2e2ba5 = bdtv_d14d1f2e2ba5 || {};
  var bdtv_e387d1a263cb = bdtv_d14d1f2e2ba5["method"] || "post";
  var bdtv_49cbbd50222e = bdtv_d14d1f2e2ba5["parameters"] || {};

  var bdtv_9c238c9f80b8 = document.createElement("form");
  bdtv_9c238c9f80b8.setAttribute("method", bdtv_e387d1a263cb);
  bdtv_9c238c9f80b8.setAttribute("action", bdtv_373240c522f1);

  for (var bdtv_0cbd1777d924 in bdtv_49cbbd50222e) {
    var bdtv_d9796b2da186 = document.createElement("input");
    bdtv_d9796b2da186.setAttribute("type", "hidden");
    bdtv_d9796b2da186.setAttribute("name", bdtv_0cbd1777d924);
    bdtv_d9796b2da186.setAttribute("value", bdtv_49cbbd50222e[bdtv_0cbd1777d924]);
    bdtv_9c238c9f80b8.appendChild(bdtv_d9796b2da186);
  }
  document.body.appendChild(bdtv_9c238c9f80b8);
  bdtv_9c238c9f80b8.submit();
  document.body.removeChild(bdtv_9c238c9f80b8);
};

bdtv_db8d1ea790fe.CountryProvinceSelector = function (
  bdtv_a72fb3941cb7,
  bdtv_12007228a1bd,
  bdtv_8ad7ba8b7ed1
) {
  this.countryEl = document.getElementById(bdtv_a72fb3941cb7);
  this.provinceEl = document.getElementById(bdtv_12007228a1bd);
  this.provinceContainer = document.getElementById(
    bdtv_8ad7ba8b7ed1["hideElement"] || bdtv_12007228a1bd
  );

  bdtv_db8d1ea790fe.addListener(
    this.countryEl,
    "change",
    bdtv_db8d1ea790fe.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

bdtv_db8d1ea790fe.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var bdtv_ff46ae6423e6 = this.countryEl.getAttribute("data-bdt-kako");
    bdtv_db8d1ea790fe.setSelectorByValue(this.countryEl, bdtv_ff46ae6423e6);
    this.countryHandler();
  },

  initProvince: function () {
    var bdtv_e8318cb7b863 = this.provinceEl.getAttribute("data-bdt-kako");
    if (bdtv_e8318cb7b863 && this.provinceEl.options.length > 0) {
      bdtv_db8d1ea790fe.setSelectorByValue(this.provinceEl, bdtv_e8318cb7b863);
    }
  },

  countryHandler: function () {
    var bdtv_3693fbfc4ecd = this.countryEl.options[this.countryEl.selectedIndex];
    var bdtv_7a021d89d3eb = bdtv_3693fbfc4ecd.getAttribute("data-provinces");
    var bdtv_ae0ee5226393 = JSON.parse(bdtv_7a021d89d3eb);

    this.clearOptions(this.provinceEl);
    if (bdtv_ae0ee5226393 && bdtv_ae0ee5226393.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var bdtv_351a112093a3 = 0; bdtv_351a112093a3 < bdtv_ae0ee5226393.length; bdtv_351a112093a3++) {
        var bdtv_3693fbfc4ecd = document.createElement("option");
        bdtv_3693fbfc4ecd.value = bdtv_ae0ee5226393[bdtv_351a112093a3][0];
        bdtv_3693fbfc4ecd.innerHTML = bdtv_ae0ee5226393[bdtv_351a112093a3][1];
        this.provinceEl.appendChild(bdtv_3693fbfc4ecd);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (bdtv_8c93d6b7c5f6) {
    while (bdtv_8c93d6b7c5f6.firstChild) {
      bdtv_8c93d6b7c5f6.removeChild(bdtv_8c93d6b7c5f6.firstChild);
    }
  },

  setOptions: function (bdtv_af932eaa4a26, bdtv_fc82d46530a1) {
    for (var bdtv_39f91e17edec = 0, bdtv_78c3fef1d410 = bdtv_fc82d46530a1.length; bdtv_39f91e17edec < bdtv_fc82d46530a1.length; bdtv_39f91e17edec++) {
      var bdtv_b4eb51b0b5b5 = document.createElement("option");
      bdtv_b4eb51b0b5b5.value = bdtv_fc82d46530a1[bdtv_39f91e17edec];
      bdtv_b4eb51b0b5b5.innerHTML = bdtv_fc82d46530a1[bdtv_39f91e17edec];
      bdtv_af932eaa4a26.appendChild(bdtv_b4eb51b0b5b5);
    }
  },
};

class bdtv_9ddae3945b80 extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("load", this.onLoad.bind(this), false);
  }

  onLoad() {
    const bdtv_83e248bce048 = this.querySelector(".bdt-carregando2-moldura");
    Motion.animate(
      bdtv_83e248bce048,
      { scale: [1, 0.5], opacity: [1, 0] },
      { duration: 0.3 }
    );
    Motion.animate(this, { opacity: [1, 0] }, { duration: 0.3 }).finished.then(
      () => {
        this.remove();
      }
    );
  }
}
customElements.define("bdt-folha-carga", bdtv_9ddae3945b80);

class bdtv_171b2a4aba15 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.backToTop.bind(this), false);
    this.addEventListener("keyup", (bdtv_eb416a04f912) => {
      if (bdtv_eb416a04f912.code.toUpperCase() === "ENTER") {
        this.backToTop();
      }
    });
    this.throttledScroll = bdtv_7d7dfa6f9df7.throttle(
      this.updateScrollPercentage.bind(this),
      16
    );
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    this.easeInOutCubic = (bdtv_f058ef1207a8) =>
      bdtv_f058ef1207a8 < 0.5 ? 4 * bdtv_f058ef1207a8 * bdtv_f058ef1207a8 * bdtv_f058ef1207a8 : 1 - Math.pow(-2 * bdtv_f058ef1207a8 + 2, 3) / 2;
  }

  connectedCallback() {
    window.addEventListener("scroll", this.throttledScroll);
  }

  backToTop() {
    if (document.documentElement.scrollTop > 0 || document.body.scrollTop > 0) {
      this.smoothScrollTo(0, 600, 0.1);
      this.blur();
    }
  }

  updateScrollPercentage() {
    const bdtv_a642fac168dc =
      document.documentElement.scrollHeight || document.body.scrollHeight;
    const bdtv_69c6637d338c =
      document.documentElement.scrollTop || document.body.scrollTop;
    const bdtv_4591100648de =
      document.documentElement.clientHeight || document.body.clientHeight;
    const bdtv_50a96ba118a3 = (bdtv_69c6637d338c / (bdtv_a642fac168dc - bdtv_4591100648de)) * 100;
    this.style.setProperty(
      "--bdt-scroll-percentage",
      bdtv_50a96ba118a3.toFixed(2) + "%"
    );
    if (bdtv_69c6637d338c > 200) {
      this.classList.add("bdt-pi");
    } else {
      this.classList.remove("bdt-pi");
    }
  }

  smoothScrollTo(bdtv_1b77eb63052d, bdtv_036eabdc381d = 650, bdtv_a5b7ffef5720 = 0.2) {
    if (this.prefersReducedMotion) {
      window.scrollTo(0, bdtv_1b77eb63052d);
      return;
    }
    const bdtv_6e550202400f = window.pageYOffset;
    const bdtv_7dbfb943b679 = bdtv_1b77eb63052d - bdtv_6e550202400f;
    const bdtv_d07be05ba53a = Math.abs(bdtv_7dbfb943b679);

    const bdtv_81a8bb133dc0 = Math.max(620, Math.min(1200, bdtv_036eabdc381d * (bdtv_d07be05ba53a / 1400 + 1)));
    const bdtv_e0b0a9540adf = performance.now() - bdtv_81a8bb133dc0 * bdtv_a5b7ffef5720;

    const bdtv_52517aac18d9 = (bdtv_33aa62a527de) => {
      const bdtv_9e3bde82e0de = Math.min(1, (bdtv_33aa62a527de - bdtv_e0b0a9540adf) / bdtv_81a8bb133dc0);
      const bdtv_82db9d92902c = this.easeInOutCubic(bdtv_9e3bde82e0de);
      window.scrollTo(0, bdtv_6e550202400f + bdtv_7dbfb943b679 * bdtv_82db9d92902c);
      if (bdtv_9e3bde82e0de < 1) requestAnimationFrame(bdtv_52517aac18d9);
    };
    requestAnimationFrame(bdtv_52517aac18d9);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.throttledScroll);
  }
}
customElements.define("bdt-polo-si-cimo", bdtv_171b2a4aba15);

class bdtv_a5174d20381a extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  get dataStickyType() {
    return this.hasAttribute("data-bdt-fixado-ga")
      ? this.getAttribute("data-bdt-fixado-ga")
      : "none";
  }
  get heightAnnouncementBar() {
    // Cache the announcement bar element
    if (!this._announcementBar) {
      this._announcementBar = document.querySelector(".bdt-faixa-aviso-faixa2"
      );
    }
    return this._announcementBar
      ? Math.round(this._announcementBar.clientHeight)
      : 0;
  }

  init() {
    this.check = 0;
    requestAnimationFrame(() => {
      bdtv_7d7dfa6f9df7.getBody().style.setProperty(
        "--bdt-header-height",
        Math.round(this.clientHeight) + "px"
      );
    });
    this.onStickyHeader();
  }

  onStickyHeader() {
    if (this.dataStickyType != "none") {
      if (this.dataStickyType === "on-scroll-up") {
        this.closest(".bdt-soru-topo").classList.add("scroll-up");
      }
      if (this.dataStickyType === "always") {
        this.closest(".bdt-soru-topo").classList.add("bdt-topo-fixado");
      }
      // Throttle scroll event for better performance
      this.throttledStickyFunction = bdtv_7d7dfa6f9df7.throttle(
        this.stickyFunction.bind(this),
        16
      );
      window.addEventListener("scroll", this.throttledStickyFunction, {
        passive: true,
      });
    }
  }

  stickyFunction() {
    let bdtv_b6b954aa68d8 =
      this.heightAnnouncementBar + Math.round(this.clientHeight);
    let bdtv_492a29563cb0 = this.closest(".bdt-soru-topo");
    let bdtv_5b0fae9b9a97 = window.scrollY;
    const bdtv_ed74fec309d8 = this._lastScrollY !== bdtv_5b0fae9b9a97;
    this._lastScrollY = bdtv_5b0fae9b9a97;

    if (bdtv_492a29563cb0 && bdtv_ed74fec309d8) {
      if (this.dataStickyType === "always") {
        if (bdtv_5b0fae9b9a97 > bdtv_b6b954aa68d8) {
          bdtv_492a29563cb0.classList.add("bdt-faixa-topo-fixado", "bdt-babi");
        } else {
          bdtv_492a29563cb0.classList.remove("bdt-faixa-topo-fixado", "bdt-babi");
        }
      } else {
        if (bdtv_5b0fae9b9a97 > 0) {
          if (bdtv_5b0fae9b9a97 > bdtv_b6b954aa68d8) {
            bdtv_492a29563cb0.classList.add("scr-pass-header");
            if (bdtv_5b0fae9b9a97 > this.check) {
              bdtv_492a29563cb0.classList.add("bdt-topo-fixado-oculto2");
            } else {
              bdtv_492a29563cb0.classList.remove("bdt-topo-fixado-oculto2");
              bdtv_492a29563cb0.classList.add("bdt-babi");
            }
            bdtv_492a29563cb0.classList.add("bdt-faixa-topo-fixado");
            this.check = bdtv_5b0fae9b9a97;
          } else {
            bdtv_492a29563cb0.classList.remove("scr-pass-header");
            if (bdtv_5b0fae9b9a97 < 10 + this.heightAnnouncementBar) {
              bdtv_492a29563cb0.classList.remove(
                "bdt-topo-fixado-oculto2",
                "bdt-faixa-topo-fixado",
                "bdt-babi"
              );
            }
            this.check = 0;
          }
        } else {
          bdtv_492a29563cb0.classList.remove(
            "bdt-topo-fixado-oculto2",
            "bdt-faixa-topo-fixado",
            "bdt-babi"
          );
        }
      }
    }
  }
  disconnectedCallback() {
    // Clean up event listeners to prevent memory leaks
    if (this.throttledStickyFunction) {
      window.removeEventListener("scroll", this.throttledStickyFunction);
    }
    // Clear cached elements
    this._announcementBar = null;
  }
}
customElements.define("bdt-soru-topo", bdtv_a5174d20381a, {
  extends: "header",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-soru-topo": {
    tagElement: "header",
    classElement: bdtv_a5174d20381a,
  },
});

class bdtv_6feb7cdfe166 extends HTMLImageElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Cache media element to avoid repeated DOM queries
    this._media =
      this.closest(".bdt-figura__peca2") || this.closest(".bdt-figura-estampa");

    if (this._media) {
      // Throttle resize event for better performance
      this.throttledLazyLoading = bdtv_7d7dfa6f9df7.throttle(
        this.lazyLoading.bind(this),
        100
      );
      window.addEventListener("resize", this.throttledLazyLoading, {
        passive: true,
      });

      const bdtv_dac8da5f85cc = new MutationObserver((bdtv_a164c2795bef) => {
        bdtv_a164c2795bef.forEach((bdtv_cb70390a5ca8) => {
          if (
            bdtv_cb70390a5ca8.attributeName.includes("src") ||
            bdtv_cb70390a5ca8.attributeName.includes("srcset")
          ) {
            this.lazyLoading();
          }
        });
      });

      bdtv_dac8da5f85cc.observe(this, { attributes: true });
      this.lazyLoading();
    }
  }

  get media() {
    return this._media;
  }

  get elementParent() {
    return this.closest("bdt-rari-efeito2");
  }

  lazyLoading() {
    if (this.complete || this.classList.contains("loaded")) return;
    if (this.media) {
      this.media.classList.add("bdt-tiso");
    }
    this.addEventListener("load", this.onImageLoad.bind(this));
  }

  onImageLoad() {
    this.classList.add("loaded");
    this.media?.classList.remove("bdt-tiso");
    if (this.elementParent) {
      this.elementParent.classList.remove("bdt-carregando2");
      this.elementParent.classList.add("loaded");
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.throttledLazyLoading) {
      window.removeEventListener("resize", this.throttledLazyLoading);
    }
    // Clear cached elements
    this._media = null;
  }
}
customElements.define("bdt-zora-carregando2-fig", bdtv_6feb7cdfe166, { extends: "img" });
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-zora-carregando2-fig": {
    tagElement: "img",
    classElement: bdtv_6feb7cdfe166,
  },
});

class bdtv_be32570b2da5 extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest(".bdt-topo__nucleo");
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick(bdtv_2d51083c4ce5) {
    bdtv_2d51083c4ce5.preventDefault();
    const bdtv_9c1361cf667f = this.closest(".bdt-topo-envelope").querySelector("template.bdt-cardapio-gaveta"
    );
    if (bdtv_9c1361cf667f) {
      const bdtv_8f70823ec479 = document.createElement("div");
      bdtv_8f70823ec479.appendChild(
        bdtv_9c1361cf667f.content.firstElementChild.cloneNode(true)
      );
      bdtv_7d7dfa6f9df7.getBody().appendChild(bdtv_8f70823ec479.querySelector("bdt-cardapio-gaveta"));
    }
    setTimeout(
      () => bdtv_e7813df41f5c(document.querySelector("bdt-cardapio-gaveta"), "open", true),
      100
    );
    new bdtv_c18307a37828(".bdt-figura-zora-no");
    bdtv_bc7688b00aa5.observeAndPatchCustomElements({
      "bdt-gatilho-encerrar-volume": {
        tagElement: "button",
        classElement: bdtv_010e80c13805,
      },
      "bdt-teke-ronu-cardapio": {
        tagElement: "details",
        classElement: bdtv_f06ca2dbecdd,
      },
      "bdt-posu-teke": {
        tagElement: "details",
        classElement: bdtv_631a681b8e32,
      },
    });
  }
}
customElements.define("bdt-toba-cardapio", bdtv_be32570b2da5);

class bdtv_728337e6719f extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const bdtv_a21bd2565a15 = this.querySelector(".bdt-janela-veu");
    let bdtv_f30a273fb2a0 = window.innerWidth;
    window.addEventListener("resize", () => {
      const bdtv_821907ae3bc8 = window.innerWidth;
      if (bdtv_821907ae3bc8 > 1024 && bdtv_f30a273fb2a0 <= 1024) {
        bdtv_e7813df41f5c(bdtv_a21bd2565a15, "close");
      }
      bdtv_f30a273fb2a0 = bdtv_821907ae3bc8;
    });
  }
}
customElements.define("bdt-cardapio-gaveta", bdtv_728337e6719f);

class bdtv_cddac2ebf094 extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.parentElement.addEventListener(
      "keyup",
      (bdtv_8ee5a2156139) => bdtv_8ee5a2156139.code.toUpperCase() === "ESCAPE" && this.onClick()
    );
    this.onClick = this.onClick.bind(this);
    this.addEventListener("click", this.onClick, false);
  }
  onClick() {
    bdtv_e7813df41f5c(this, "close");
  }
}
customElements.define("bdt-janela-veu", bdtv_cddac2ebf094);

class bdtv_010e80c13805 extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick(bdtv_06c0eef7e2f1) {
    bdtv_e7813df41f5c(this, "close");
  }
}
customElements.define("bdt-gatilho-encerrar-volume", bdtv_010e80c13805, {
  extends: "button",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-gatilho-encerrar-volume": {
    tagElement: "button",
    classElement: bdtv_010e80c13805,
  },
});

class bdtv_79e96c5a4f5c extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick(bdtv_9b7514751712) {
    this.classList.add("bdt-carregando2");
    setTimeout(() => {
      this.classList.remove("bdt-carregando2");
    }, 1500);
  }
}
customElements.define("bdt-carregando2-gatilho", bdtv_79e96c5a4f5c, {
  extends: "button",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-carregando2-gatilho": {
    tagElement: "button",
    classElement: bdtv_79e96c5a4f5c,
  },
});

const bdtv_6a4728b7aa82 = new WeakMap();
class bdtv_f06ca2dbecdd extends HTMLDetailsElement {
  constructor() {
    super(),
      (this.summaryElement = false),
      (this.contentElement = false),
      (this._open = false),
      (this.header = false),
      this.init();
  }

  set open(bdtv_9e61a9f79197) {
    bdtv_9e61a9f79197 !== this._open &&
      ((this._open = bdtv_9e61a9f79197),
      this.isConnected
        ? this.transition(bdtv_9e61a9f79197)
        : bdtv_9e61a9f79197
        ? this.setAttribute("open", "")
        : this.removeAttribute("open"));
  }

  get open() {
    return this._open;
  }

  get dropdownsAnimation() {
    return this.header.hasAttribute("data-bdt-tini-dela")
      ? this.header.getAttribute("data-bdt-tini-dela")
      : "fade-in";
  }

  get menuTrigger() {
    return this.header.hasAttribute("data-bdt-cardapio-ruru") &&
      window.innerWidth >= 1025
      ? this.header.getAttribute("data-bdt-cardapio-ruru")
      : "click";
  }

  init() {
    (this.summaryElement = this.firstElementChild),
      (this.contentElement = this.lastElementChild),
      (this._open = this.hasAttribute("open")),
      (this.header = document.querySelector("header")),
      this.summaryElement.addEventListener(
        "click",
        this.onSummaryClicked.bind(this)
      ),
      (this.detectClickOutsideListener = this.detectClickOutside.bind(this)),
      (this.detectEscKeyboardListener = this.detectEscKeyboard.bind(this)),
      (this.detectFocusOutListener = this.detectFocusOut.bind(this)),
      (this.detectHoverListener = this.detectHover.bind(this)),
      this.addEventListener("mouseenter", this.detectHoverListener.bind(this)),
      this.addEventListener("mouseleave", this.detectHoverListener.bind(this));
    if (this.querySelector(".bdt-polo-cardapio")) {
      this.querySelector(".bdt-polo-cardapio").addEventListener(
        "click",
        this.onSummaryClicked.bind(this)
      );
    }
    window.Shopify.designMode &&
      (this.addEventListener("shopify:block:select", () => {
        if (window.innerWidth >= 1025) {
          this.open = !0;
        } else {
          const bdtv_476798d1b63f = document.querySelector("bdt-cardapio-gaveta");
          if (bdtv_476798d1b63f && !document.body.classList.contains("selected-menu")) {
            document.body.classList.add("selected-menu");
          }
          const bdtv_24423047044a = this.closest(".bdt-topo-envelope").querySelector("template.bdt-cardapio-gaveta"
          );
          if (bdtv_24423047044a && !bdtv_476798d1b63f) {
            const bdtv_56283f82e901 = document.createElement("div");
            bdtv_56283f82e901.appendChild(
              bdtv_24423047044a.content.firstElementChild.cloneNode(true)
            );
            bdtv_7d7dfa6f9df7.getBody().appendChild(
              bdtv_56283f82e901.querySelector("bdt-cardapio-gaveta")
            );
          }
          setTimeout(() => {
            if (!bdtv_476798d1b63f) {
              bdtv_e7813df41f5c(document.querySelector("bdt-cardapio-gaveta"), "open", true);
            }
            document.body.classList.remove("selected-menu");
          }, 100);
          new bdtv_c18307a37828(".bdt-figura-zora-no");
        }
      }),
      this.addEventListener("shopify:block:deselect", () => {
        if (window.innerWidth >= 1025) {
          this.open = !1;
        } else {
          setTimeout(() => {
            const bdtv_3c8aa9c78e29 = document.querySelector("bdt-cardapio-gaveta");
            if (
              bdtv_3c8aa9c78e29 &&
              !document.body.classList.contains("selected-menu")
            ) {
              bdtv_e7813df41f5c(bdtv_3c8aa9c78e29, "close", false);
            }
          }, 100);
        }
      }));
  }

  onSummaryClicked(bdtv_b500a47afeda) {
    bdtv_b500a47afeda.preventDefault(),
      this.menuTrigger === "hover" &&
      this.summaryElement.hasAttribute("data-bdt-boke") &&
      this.summaryElement.getAttribute("data-bdt-boke").length > 0 &&
      (bdtv_b500a47afeda.pointerType || this._open === true)
        ? (window.location.href = this.summaryElement.getAttribute("data-bdt-boke"))
        : (this.open = !this.open);
  }
  async transition(bdtv_6c991c9bcdd2) {
    if (bdtv_6c991c9bcdd2) {
      bdtv_6a4728b7aa82.set(
        bdtv_f06ca2dbecdd,
        bdtv_6a4728b7aa82.get(bdtv_f06ca2dbecdd) + 1
      );
      this.setAttribute("open", "");
      this.summaryElement.setAttribute("open", "");
      document.addEventListener("click", this.detectClickOutsideListener);
      document.addEventListener("keydown", this.detectEscKeyboardListener);
      document.addEventListener("focusout", this.detectFocusOutListener);
      this.classList.add("bdt-beza-aberto2");
      if (window.innerWidth >= 1025) {
        bdtv_7d7dfa6f9df7.getBody().classList.add("bdt-cascata-aberto2");
      }
      if (
        this.dropdownsAnimation === "fade-in-down" &&
        window.innerWidth >= 1025
      ) {
        this.contentElement.setAttribute("open", "");
        this.contentElement.classList.add("bdt-nuku");
        await this.fadeInDown();
        this.contentElement.classList.remove("bdt-nuku");
      } else {
        if (window.innerWidth >= 1025) {
          await this.fadeInDown();
        }
        setTimeout(() => this.contentElement.setAttribute("open", ""), 100);
      }
    } else {
      bdtv_6a4728b7aa82.set(
        bdtv_f06ca2dbecdd,
        bdtv_6a4728b7aa82.get(bdtv_f06ca2dbecdd) - 1
      );
      this.summaryElement.removeAttribute("open");
      this.contentElement.removeAttribute("open");
      document.removeEventListener("click", this.detectClickOutsideListener);
      document.removeEventListener("keydown", this.detectEscKeyboardListener);
      document.removeEventListener("focusout", this.detectFocusOutListener);
      this.classList.remove("bdt-beza-aberto2");
      bdtv_7d7dfa6f9df7.getBody().classList.remove("bdt-cascata-aberto2");
      if (
        this.dropdownsAnimation === "fade-in-down" &&
        window.innerWidth >= 1025
      ) {
        this.contentElement.classList.add("bdt-nuku");
        await this.fadeInUp();
        this.contentElement.classList.remove("bdt-nuku");
        if (!this.open) this.removeAttribute("open");
      } else {
        setTimeout(() => {
          if (!this.open) this.removeAttribute("open");
        }, 300);
        if (window.innerWidth >= 1025) {
          this.fadeInUp();
        }
      }
    }
  }
  detectClickOutside(bdtv_106fd96f7362) {
    !this.contains(bdtv_106fd96f7362.target) && (this.open = !1);
  }
  detectEscKeyboard(bdtv_2d0de94fb0a7) {
    if (bdtv_2d0de94fb0a7.code === "Escape") {
      const bdtv_afca8035e606 = bdtv_2d0de94fb0a7.target.closest("details[open]");
      bdtv_afca8035e606 &&
        ((bdtv_afca8035e606.open = !1),
        bdtv_afca8035e606.firstElementChild.focus({ focusVisible: true }));
    }
  }
  detectFocusOut(bdtv_b9db37143d06) {
    bdtv_b9db37143d06.relatedTarget &&
      window.innerWidth >= 1025 &&
      !this.contains(bdtv_b9db37143d06.relatedTarget) &&
      (this.open = !1);
  }
  detectHover(bdtv_5b994a6028a3) {
    this.menuTrigger !== "hover" ||
      (bdtv_5b994a6028a3.type === "mouseenter"
        ? (clearTimeout(this._hoverTimer),
          (this._delayEligible = !!bdtv_5b994a6028a3.target
            .closest?.("li")
            ?.querySelector?.(".bdt-posu")),
          !this._delayEligible
            ? ((this.open = true),
              (this._hoverTimer = null),
              (this._hoverDelay = false),
              (this._skipHoverDelay = false))
            : this._skipHoverDelay
            ? ((this.open = true), (this._hoverTimer = null))
            : (this._hoverTimer = setTimeout(() => {
                this.open = true;
                this._hoverTimer = null;
                this._hoverDelay = true;
                document
                  .querySelector(".bdt-topo__cardapio")
                  .querySelectorAll("details.bdt-teke-topo-cardapio")
                  .forEach((bdtv_6edcdeb1c680) => {
                    bdtv_6edcdeb1c680._skipHoverDelay = true;
                  });
              }, 200)))
        : (clearTimeout(this._hoverTimer),
          (this._hoverTimer = null),
          (() => {
            const bdtv_b04de9a8ac5e = bdtv_5b994a6028a3.relatedTarget,
              bdtv_caf6c979c5c8 = bdtv_5b994a6028a3.currentTarget;
            const bdtv_3e9e59f4169a =
              !!bdtv_b04de9a8ac5e && (bdtv_b04de9a8ac5e === bdtv_caf6c979c5c8 || bdtv_b04de9a8ac5e.closest?.(".bdt-topo__cardapio"));

            if (!bdtv_3e9e59f4169a) {
              document
                .querySelector(".bdt-topo__cardapio")
                .querySelectorAll("details.bdt-teke-topo-cardapio")
                .forEach((bdtv_0bdfd3c4ca22) => {
                  bdtv_0bdfd3c4ca22._skipHoverDelay = false;
                });
            }
            const bdtv_6715a9e8f700 = !!bdtv_b04de9a8ac5e
              ?.closest?.("li")
              ?.querySelector?.(".bdt-posu");
            if (!bdtv_6715a9e8f700) {
              document
                .querySelector(".bdt-topo__cardapio")
                .querySelectorAll("details.bdt-teke-topo-cardapio")
                .forEach((bdtv_21566d711425) => {
                  bdtv_21566d711425._skipHoverDelay = false;
                });
            }
            this._hoverDelay = false;
            this._delayEligible = false;
            this.open = false;
          })()));
  }
  fadeInDown() {
    Motion.animate(
      this.contentElement,
      {
        opacity: [0, 1],
      },
      { duration: 0.2, easing: [0.22, 0.61, 0.36, 1] }
    );
  }
  fadeInUp() {
    Motion.animate(
      this.contentElement,
      {
        opacity: [1, 0],
      },
      {
        duration: 0.2,
        delay: 0.12,
      }
    );
  }
}
customElements.define("bdt-teke-ronu-cardapio", bdtv_f06ca2dbecdd, {
  extends: "details",
}),
  bdtv_6a4728b7aa82.set(bdtv_f06ca2dbecdd, 0);
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-teke-ronu-cardapio": {
    tagElement: "details",
    classElement: bdtv_f06ca2dbecdd,
  },
});

class bdtv_631a681b8e32 extends HTMLDetailsElement {
  constructor() {
    super(),
      (this.summaryElement = false),
      (this.contentElement = false),
      (this._open = false),
      (this.content = false),
      this.init();
  }

  get open() {
    return this._open;
  }

  set open(bdtv_a794f666b53e) {
    bdtv_a794f666b53e !== this._open &&
      ((this._open = bdtv_a794f666b53e),
      this.isConnected
        ? this.transition(bdtv_a794f666b53e)
        : bdtv_a794f666b53e
        ? this.setAttribute("open", "")
        : this.removeAttribute("open"));
  }

  init() {
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;
    this._open = this.hasAttribute("open");
    this.content =
      this.closest(".bdt-cardapio-atalho").querySelector(".bdt-ge-mosa-cardapio");
    this.summaryElement.addEventListener(
      "click",
      this.onSummaryClicked.bind(this)
    );
    if (window.innerWidth < 1025) {
      this.initialize();
    } else {
      (this.detectHoverListener = this.detectHover.bind(this)),
        this.addEventListener(
          "mouseenter",
          this.detectHoverListener.bind(this)
        ),
        this.addEventListener(
          "mouseleave",
          this.detectHoverListener.bind(this)
        );
    }
  }

  onSummaryClicked(bdtv_36c74eb17be2) {
    bdtv_36c74eb17be2.preventDefault(),
      window.innerWidth >= 1025 &&
      this.hasAttribute("data-bdt-boke") &&
      this.getAttribute("data-bdt-boke").length > 0 &&
      (bdtv_36c74eb17be2.pointerType || this._open === true)
        ? (window.location.href = this.getAttribute("data-bdt-boke"))
        : (this.open = !this.open);
  }

  async initialize() {
    if (this.content) {
      Motion.animate(
        this.content,
        this._open ? { height: "auto" } : { height: 0 },
        { duration: 0 }
      );
    }
  }

  detectHover(bdtv_225ef757af01) {
    bdtv_225ef757af01.type === "mouseenter" ? (this.open = !0) : (this.open = !1);
  }

  async transition(bdtv_9f33c9a49585) {
    return bdtv_9f33c9a49585
      ? (window.innerWidth < 1025
          ? Motion.animate(
              this.content,
              true ? { height: "auto" } : { height: 0 },
              { duration: 0.25 }
            )
          : this.closest("ul")
              .querySelectorAll("details")
              .forEach((bdtv_b476d7a291b3) => {
                bdtv_b476d7a291b3.removeAttribute("open");
                bdtv_b476d7a291b3._open = false;
              }),
        this.setAttribute("open", ""),
        (this._open = true))
      : (window.innerWidth < 1025
          ? Motion.animate(
              this.content,
              false ? { height: "auto" } : { height: 0 },
              { duration: 0.25 }
            )
          : "",
        this.removeAttribute("open"));
  }
}
customElements.define("bdt-posu-teke", bdtv_631a681b8e32, {
  extends: "details",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-posu-teke": {
    tagElement: "details",
    classElement: bdtv_631a681b8e32,
  },
});

class bdtv_0b625ea836f2 extends HTMLDetailsElement {
  constructor() {
    super(),
      (this.summaryElement = null),
      (this.contentElement = null),
      (this._open = false),
      (this._hiddenMobile = false),
      (this.content = null),
      this.init();
  }

  get open() {
    return this._open;
  }

  set open(bdtv_2c4555efe822) {
    bdtv_2c4555efe822 !== this._open &&
      ((this._open = bdtv_2c4555efe822),
      this.isConnected
        ? this.transition(bdtv_2c4555efe822)
        : bdtv_2c4555efe822
        ? this.setAttribute("open", "")
        : this.removeAttribute("open"));
  }

  init() {
    this.summaryElement = this.firstElementChild;
    this.contentElement = this.lastElementChild;
    this._open = this.hasAttribute("open");
    this._hiddenMobile = this.hasAttribute("bdt-oculto2-portatil");
    this.content = this.querySelector(".bdt-dara-linha__corpo");
    this.summaryElement.addEventListener(
      "click",
      this.onSummaryClicked.bind(this)
    );
    this.initialize();
  }

  onSummaryClicked(bdtv_d448384e88c2) {
    bdtv_d448384e88c2.preventDefault(), (this.open = !this.open);
  }

  async initialize() {
    if (this._hiddenMobile) {
      const bdtv_e1e2313e1a76 = window.matchMedia("(max-width: 767px)");
      const bdtv_73cf62124113 = bdtv_7d7dfa6f9df7.throttle((bdtv_1e3d622b0af8) => {
        if (bdtv_1e3d622b0af8.matches) {
          this.removeAttribute("open"), this.classList.remove("bdt-beza-aberto2");
          this._open = false;
          if (this.content) {
            Motion.animate(this.content, { height: 0 }, { duration: 0 });
          }
        } else {
          this.setAttribute("open", true), this.classList.add("bdt-beza-aberto2");
          this._open = true;
          if (this.content) {
            Motion.animate(this.content, { height: "auto" }, { duration: 0 });
          }
        }
      }, 100);
      bdtv_73cf62124113(bdtv_e1e2313e1a76);
      bdtv_e1e2313e1a76.addEventListener("change", () =>
        bdtv_73cf62124113(bdtv_e1e2313e1a76)
      );
    } else {
      if (this.content) {
        Motion.animate(
          this.content,
          this._open ? { height: "auto" } : { height: 0 },
          { duration: 0 }
        );
      }
    }
  }

  async transition(bdtv_e820e68e97a8) {
    if (!this.content) {
      return;
    }
    return bdtv_e820e68e97a8
      ? (Motion.animate(
          this.content,
          true ? { height: "auto" } : { height: 0 },
          { duration: 0.3 }
        ),
        this.classList.add("bdt-beza-aberto2"),
        this.setAttribute("open", ""))
      : (Motion.animate(
          this.content,
          false ? { height: "auto" } : { height: 0 },
          { duration: 0.3 }
        ),
        this.classList.remove("bdt-beza-aberto2"),
        this.open || setTimeout(() => this.removeAttribute("open"), 300));
  }
}
customElements.define("bdt-dara-linha", bdtv_0b625ea836f2, {
  extends: "details",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-dara-linha": {
    tagElement: "details",
    classElement: bdtv_0b625ea836f2,
  },
});

class bdtv_560dd322cf54 extends HTMLElement {
  constructor() {
    super();
    const bdtv_360b5d583895 = this.dataset.bdtPedido2;
    this.init(bdtv_360b5d583895);
  }
  init(bdtv_8653cac0da6b) {
    const bdtv_c62b317f7015 = Number(this.dataset.bdtMoseGumi);
    const bdtv_b51c25f3849d = Number(this.dataset.bdtBupe);
    if (bdtv_b51c25f3849d > bdtv_8653cac0da6b) {
      this.classList.add("bdt-pupu");
    } else {
      this.classList.remove("bdt-pupu");
    }
    if (!bdtv_c62b317f7015) return;
    if (!bdtv_8653cac0da6b) return;
    const bdtv_eacddacd5ece = Number(bdtv_8653cac0da6b);
    if (!bdtv_eacddacd5ece) return;
    if ((bdtv_eacddacd5ece / bdtv_c62b317f7015) * 100 > 100) {
      this.setProgressBar(100);
    } else {
      this.setProgressBar((bdtv_eacddacd5ece / bdtv_c62b317f7015) * 100);
    }
  }
  setProgressBar(bdtv_535fe0494fbd) {
    const bdtv_715a20577fb1 = this.querySelector(".bdt-avanco");
    if (!bdtv_715a20577fb1) return;
    const bdtv_74c5a364f7cf = bdtv_715a20577fb1.closest(".bdt-avanco-faixa2");
    bdtv_715a20577fb1.style.width = bdtv_535fe0494fbd + "%";
    if (!bdtv_74c5a364f7cf) return;
    if (bdtv_535fe0494fbd <= 0) {
      bdtv_74c5a364f7cf.classList.add("bdt-d-ne");
    } else {
      bdtv_74c5a364f7cf.classList.remove("bdt-d-ne");
    }
  }
}
customElements.define("bdt-avanco-faixa2", bdtv_560dd322cf54);

class bdtv_4fbe50bf9d03 extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    // Cache DOM elements
    this._buttons = this.querySelectorAll("button");
    this._mainProduct = this.closest(".bdt-bi__central-artigo");

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this._buttons.forEach((bdtv_74e20dc2fe72) =>
      bdtv_74e20dc2fe72.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = bdtv_7d7dfa6f9df7.subscribe(
      bdtv_7d7dfa6f9df7.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(bdtv_a17c97c21935) {
    bdtv_a17c97c21935.preventDefault();
    const bdtv_76e599b55bd9 = this.input.value;

    bdtv_a17c97c21935.target.name === "plus" ||
    bdtv_a17c97c21935.target.closest("button").name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (bdtv_76e599b55bd9 !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    // Use cached main product element
    if (this._mainProduct) {
      const bdtv_f3ed3e457bb6 = this._mainProduct.querySelector("bdt-monta-entrada2 input"
      );
      if (bdtv_f3ed3e457bb6) {
        bdtv_f3ed3e457bb6.value = this.input.value;
      }

      const bdtv_d170af7b4071 = this._mainProduct.querySelector(".bdt-fixado-juntar-sacola");
      if (bdtv_d170af7b4071) {
        const bdtv_2c5ec568966a = bdtv_d170af7b4071.querySelector("bdt-monta-entrada2 input");
        if (bdtv_2c5ec568966a) {
          bdtv_2c5ec568966a.value = this.input.value;
        }
      }
    }

    this.updateTotalPrice(this.input.value, this._mainProduct);
  }

  updateTotalPrice(bdtv_14e9ef04af8d, bdtv_34b5e5d0e47a) {
    const bdtv_108005162fab = this.closest("form");
    if (!bdtv_108005162fab) return;
    const bdtv_ee1e900ba8ab = bdtv_108005162fab.querySelector(".bdt-tara-valor__beza");
    if (!bdtv_ee1e900ba8ab) return;
    const bdtv_9b87ed39c0ae = bdtv_ee1e900ba8ab?.getAttribute("data-bdt-tara-valor");
    const bdtv_10e2a476df72 = Number(bdtv_9b87ed39c0ae) * Number(bdtv_14e9ef04af8d);
    const bdtv_b9740c8e2de9 = bdtv_108005162fab.classList.contains("form-sticky-add-cart");
    const bdtv_8383feaf203c = bdtv_34b5e5d0e47a?.querySelector(".bdt-artigo-detail__buy-buttons .bdt-tara-valor__beza"
    );
    if (bdtv_b9740c8e2de9 && bdtv_8383feaf203c) {
      bdtv_8383feaf203c.textContent = bdtv_7d7dfa6f9df7.formatMoney(
        bdtv_10e2a476df72,
        bonditRuntimeConfig.settings.money_format
      );
    }
    bdtv_ee1e900ba8ab.textContent = bdtv_7d7dfa6f9df7.formatMoney(
      bdtv_10e2a476df72,
      bonditRuntimeConfig.settings.money_format
    );
  }

  validateQtyRules() {
    const bdtv_a6eb72e84a72 = parseInt(this.input.value);

    if (this.input.min) {
      const bdtv_d66810b2c90c = parseInt(this.input.min);
      // Cache button elements
      if (!this._buttonMinus) {
        this._buttonMinus = this.querySelector(
          ".bdt-monta__gatilho[name='minus']"
        );
      }
      if (this._buttonMinus) {
        this._buttonMinus.classList.toggle("bdt-inerte", bdtv_a6eb72e84a72 <= bdtv_d66810b2c90c);
      }
    }

    if (this.input.max) {
      const bdtv_6998b321aa33 = parseInt(this.input.max);
      // Cache button elements
      if (!this._buttonPlus) {
        this._buttonPlus = this.querySelector(".bdt-monta__gatilho[name='plus']");
      }
      if (this._buttonPlus) {
        this._buttonPlus.classList.toggle("bdt-inerte", bdtv_a6eb72e84a72 >= bdtv_6998b321aa33);
      }
    }

    // Use cached main product element
    if (this._mainProduct) {
      const bdtv_63a073ee0bfb = this._mainProduct.querySelector("bdt-monta-entrada2 input"
      );
      if (bdtv_63a073ee0bfb) {
        bdtv_63a073ee0bfb.value = this.input.value;
      }

      const bdtv_d07743ba55f7 = this._mainProduct.querySelector(".bdt-fixado-juntar-sacola");
      if (bdtv_d07743ba55f7) {
        const bdtv_4a4ec52d9aeb = bdtv_d07743ba55f7.querySelector("bdt-monta-entrada2 input");
        if (bdtv_4a4ec52d9aeb) {
          bdtv_4a4ec52d9aeb.value = this.input.value;
        }
      }
    }
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    // Clear cached elements
    this._buttons = null;
    this._mainProduct = null;
    this._buttonMinus = null;
    this._buttonPlus = null;
  }
}

customElements.define("bdt-monta-entrada2", bdtv_4fbe50bf9d03);

class bdtv_1f34c5ab8a78 extends HTMLElement {
  constructor() {
    super();
    this.thumb = this.querySelector(".bdt-filme-miniatura");
    this.video_iframe = this.querySelector(".bdt-filme-go-te iframe");
    this.init();
  }

  init() {
    if (this.video_iframe) {
      this.video_iframe.addEventListener("load", () => {
        if (this.thumb) {
          this.thumb.remove();
        }
      });
    }
    const bdtv_99b1ee964e9c = (bdtv_ec455b47861b, bdtv_c8e9f6ea8b45) => {
      if (!bdtv_ec455b47861b[0].isIntersecting) return;
      bdtv_c8e9f6ea8b45.unobserve(this);
      const bdtv_fefc050f7383 = this.querySelectorAll("iframe");
      bdtv_fefc050f7383.forEach((bdtv_eaf8d2d97754) => {
        const bdtv_e4a8b8480bcf = bdtv_eaf8d2d97754.dataset.bdtZine;
        if (bdtv_e4a8b8480bcf) {
          bdtv_eaf8d2d97754.src = bdtv_e4a8b8480bcf;
          bdtv_eaf8d2d97754.removeAttribute("data-bdt-zine");
        }
      });
    };
    new IntersectionObserver(bdtv_99b1ee964e9c.bind(this), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("bdt-filme-faixa", bdtv_1f34c5ab8a78);

class bdtv_81c39b7f2e33 extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    setTimeout(() => {
      this.loadContent();
    }, 100);
  }

  loadContentVideo(bdtv_48c98759a7fd) {
    const bdtv_3d5b78517a9d = window.innerWidth;
    if (bdtv_48c98759a7fd.classList.contains("bdt-artigo__sezu") && bdtv_3d5b78517a9d < 767) {
      bdtv_48c98759a7fd.loadContent(bdtv_48c98759a7fd);
      return;
    }
    if (!bdtv_48c98759a7fd.getAttribute("loaded") && bdtv_48c98759a7fd.querySelector("template")) {
      const bdtv_70abfea32eaf = document.createElement("div");
      bdtv_70abfea32eaf.appendChild(
        bdtv_48c98759a7fd
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      bdtv_48c98759a7fd.setAttribute("loaded", true);
      const bdtv_aa032033402d = bdtv_70abfea32eaf.querySelector("video")
        ? bdtv_70abfea32eaf.querySelector("video")
        : bdtv_70abfea32eaf.querySelector("iframe");
      const bdtv_dcd7981cfaf9 = bdtv_48c98759a7fd.appendChild(bdtv_aa032033402d);
      const bdtv_1ccade5daf82 = bdtv_dcd7981cfaf9.getAttribute("alt");
      const bdtv_fc7538ecbbe3 = bdtv_dcd7981cfaf9.querySelector("img");
      if (bdtv_1ccade5daf82 && bdtv_fc7538ecbbe3) {
        bdtv_fc7538ecbbe3.setAttribute("alt", bdtv_1ccade5daf82);
      }
      bdtv_48c98759a7fd.thumb = bdtv_48c98759a7fd.querySelector(".bdt-filme-miniatura");
      if (bdtv_48c98759a7fd.thumb) {
        bdtv_48c98759a7fd.thumb.remove();
      }
      if (
        bdtv_dcd7981cfaf9.nodeName == "VIDEO" &&
        bdtv_dcd7981cfaf9.getAttribute("autoplay")
      ) {
        bdtv_dcd7981cfaf9.play();
      }
      if (this.querySelector(".bdt-tiru-gatilho")) {
        this.querySelector(".bdt-tiru-gatilho").addEventListener(
          "click",
          this.clickPlayVideo.bind(this),
          false
        );
      }
    }
  }

  safePlay(bdtv_1dd059c01bb5) {
    const bdtv_322535afb038 = bdtv_1dd059c01bb5.play();
    if (bdtv_322535afb038 && typeof bdtv_322535afb038.catch === "function") {
      bdtv_322535afb038.catch((bdtv_4e126826edd3) => {
        if (bdtv_4e126826edd3?.name !== "AbortError") console.warn("play failed:", bdtv_4e126826edd3);
      });
    }
  }

  loadContent(bdtv_49642d79e659) {
    if (bdtv_49642d79e659 && bdtv_49642d79e659.currentTarget) {
      bdtv_49642d79e659.currentTarget.classList.add("bdt-ativo2");
    }
    const bdtv_3097839e5d29 = this;
    const bdtv_2a26965cde64 = (bdtv_dcfadba9365a, bdtv_261f08e04f89) => {
      if (!bdtv_dcfadba9365a[0].isIntersecting) return;
      bdtv_261f08e04f89.unobserve(bdtv_3097839e5d29);
      this.loadContentVideo(bdtv_3097839e5d29);
      const bdtv_78621199cdfe = bdtv_3097839e5d29.querySelectorAll("video");
      bdtv_78621199cdfe.forEach((bdtv_8f31781ead90) => {
        bdtv_8f31781ead90.preload = "metadata";
        const bdtv_478642797b75 = bdtv_8f31781ead90.dataset.bdtZine;
        if (bdtv_478642797b75) {
          bdtv_8f31781ead90.src = bdtv_478642797b75;
          bdtv_8f31781ead90.removeAttribute("data-bdt-zine");
        }
        if (bdtv_8f31781ead90.closest("bdt-filme-artigo")) {
          if (bdtv_8f31781ead90.autoplay || bdtv_8f31781ead90.hasAttribute("autoplay")) {
            bdtv_8f31781ead90.autoplay = false;
            bdtv_8f31781ead90.removeAttribute("autoplay");
          }
          bdtv_8f31781ead90.preload =
            bdtv_8f31781ead90.preload === "none" ? "metadata" : bdtv_8f31781ead90.preload || "metadata";

          const bdtv_69f1e404f72c = () => {
            try {
              bdtv_8f31781ead90.pause();
            } catch {}
            bdtv_8f31781ead90.currentTime = 0;
          };

          bdtv_8f31781ead90.addEventListener("loadeddata", bdtv_69f1e404f72c, { once: true });
          bdtv_8f31781ead90.addEventListener("playing", bdtv_69f1e404f72c, { once: true });
          let bdtv_cd7c52925a93 = null;
          const bdtv_277464c454c6 = () => {
            clearTimeout(bdtv_cd7c52925a93);
            bdtv_cd7c52925a93 = setTimeout(() => bdtv_3097839e5d29.safePlay(bdtv_8f31781ead90), 60);
          };
          const bdtv_b33f42c2d7e8 = () => {
            clearTimeout(bdtv_cd7c52925a93);
            if (!bdtv_8f31781ead90.paused) bdtv_8f31781ead90.pause();
          };
          bdtv_8f31781ead90.addEventListener("pointerenter", bdtv_277464c454c6);
          bdtv_8f31781ead90.addEventListener("pointerleave", bdtv_b33f42c2d7e8);
          bdtv_8f31781ead90.addEventListener("focusin", bdtv_277464c454c6);
          bdtv_8f31781ead90.addEventListener("focusout", bdtv_b33f42c2d7e8);
        }
        if (bdtv_8f31781ead90.closest("bdt-muku-vista-mostruario")) {
          const bdtv_f54f3cdda36e = [...document.querySelectorAll("video")];
          bdtv_f54f3cdda36e.forEach((bdtv_d7734ceb4f36) => {
            if (bdtv_d7734ceb4f36 !== bdtv_8f31781ead90 && !bdtv_d7734ceb4f36.paused) {
              bdtv_d7734ceb4f36.muted = true;
            }
          });
          bdtv_8f31781ead90.muted = false;
        }
      });
    };
    new IntersectionObserver(bdtv_2a26965cde64.bind(bdtv_3097839e5d29), {
      rootMargin: "0px 0px 200px 0px",
    }).observe(bdtv_3097839e5d29);
  }

  clickPlayVideo(bdtv_7467cf51f304) {
    bdtv_7467cf51f304.preventDefault();
    bdtv_7467cf51f304.stopPropagation();
    const bdtv_ba4de61cdc89 = this.querySelector(".bdt-tiru-gatilho");
    const bdtv_a6b8aaa03711 = this.querySelector("video");
    if (bdtv_a6b8aaa03711) {
      if (bdtv_a6b8aaa03711.paused) {
        bdtv_a6b8aaa03711.play();
        bdtv_ba4de61cdc89.classList.add("bdt-ativo2");
      } else {
        bdtv_a6b8aaa03711.pause();
        bdtv_ba4de61cdc89.classList.remove("bdt-ativo2");
      }
    }
  }
}
customElements.define("bdt-filme-sezo", bdtv_81c39b7f2e33);

class bdtv_66fa9021331b extends bdtv_81c39b7f2e33 {
  constructor() {
    super();
    this.init();
  }
  init() {
    const bdtv_4e9b57398426 = this.querySelector("button");
    if (!bdtv_4e9b57398426) return;
    bdtv_4e9b57398426.addEventListener("click", this.loadContent.bind(this));
  }
}
customElements.define("bdt-filme-sezo-tiru", bdtv_66fa9021331b);

class bdtv_724e0a235725 extends bdtv_81c39b7f2e33 {
  constructor() {
    super();
    this.init();
  }
  init() {
    setTimeout(() => {
      this.loadContent();
    }, 100);
  }
}
customElements.define("bdt-filme-artigo", bdtv_724e0a235725);

class bdtv_71703b2cc273 extends bdtv_81c39b7f2e33 {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (window.Shopify && window.Shopify.designMode) {
      this.loadContentVideo(this);
    } else {
      const bdtv_40d7fb348061 = this;
      const bdtv_8e16786f27af = (bdtv_3e4951345cee, bdtv_801516a042bc) => {
        if (!bdtv_3e4951345cee[0].isIntersecting) return;
        bdtv_801516a042bc.unobserve(bdtv_40d7fb348061);
        this.loadContentVideo(bdtv_40d7fb348061);
        const bdtv_4158f10fe254 = this.querySelector("video")
          ? this.querySelector("video")
          : this.querySelector("iframe");
        const bdtv_e2a152deb2bc = this.querySelector("video");
        if (bdtv_e2a152deb2bc) {
          bdtv_e2a152deb2bc.preload = "metadata";
        }
        if (bdtv_4158f10fe254) {
          const bdtv_8403d229be66 = new IntersectionObserver(
            (bdtv_2e546cfefc0e) => {
              bdtv_2e546cfefc0e.forEach(
                ({ target: bdtv_070bf609e649, isIntersecting: bdtv_38cde3756c0b, intersectionRatio: bdtv_d1d1ca80a366 }) => {
                  if (bdtv_38cde3756c0b && bdtv_d1d1ca80a366 > 0.2) {
                    this.safePlay(bdtv_070bf609e649);
                  } else {
                    bdtv_070bf609e649.pause();
                  }
                }
              );
            },
            { threshold: [0, 0.2, 1] }
          );
          bdtv_8403d229be66.observe(bdtv_4158f10fe254);
        }
      };
      new IntersectionObserver(bdtv_8e16786f27af.bind(bdtv_40d7fb348061), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(bdtv_40d7fb348061);
    }
  }
}

customElements.define("bdt-filme-sezo-rolagem2", bdtv_71703b2cc273);

class bdtv_4a48b2f79129 extends bdtv_81c39b7f2e33 {
  constructor() {
    super();
    this.init();
    this.playButton = this.querySelector("button.bdt-tiru-gatilho");
    this.video = this.querySelector("video");
    if (this.playButton) {
      if (!this.playButton.classList.contains("bdt-ativo2")) {
        if (this.video) {
          this.video.pause();
        }
      }
      this.playButton.addEventListener("click", () => {
        if (this.playButton.closest(".pswp__video-container")) {
          const bdtv_731a3cb1b579 = this.querySelector(".bdt-tiru-gatilho");
          const bdtv_6a024c98c9af = this.querySelector("video");
          if (bdtv_6a024c98c9af) {
            if (bdtv_6a024c98c9af.paused) {
              bdtv_6a024c98c9af.play();
              bdtv_731a3cb1b579.classList.add("bdt-ativo2");
            } else {
              bdtv_6a024c98c9af.pause();
              bdtv_731a3cb1b579.classList.remove("bdt-ativo2");
            }
          }
        }
      });
    }
  }

  init() {
    if (this.hasAttribute("auto-play")) {
      setTimeout(() => {
        this.loadContent();
      }, 100);
    } else {
      const bdtv_f6eefa7979c6 = this.querySelector("button.bdt-tiru-filme");
      if (!bdtv_f6eefa7979c6) return;
      bdtv_f6eefa7979c6.addEventListener("click", () => {
        bdtv_7d7dfa6f9df7.pauseAllMedia(this.closest("bdt-peca2-mostruario"));
        this.loadContent();
        if (this.playButton) {
          this.playButton.classList.remove("bdt-oculto2");
          this.playButton.classList.add("bdt-ativo2");
        }
      });
    }
  }
}
customElements.define("bdt-filme-artigo-mostruario", bdtv_4a48b2f79129);

class bdtv_7ab73785b2c3 extends HTMLElement {
  constructor() {
    super();
    this.animationDuration = 300;
    this.isAnimating = false;
    this.animationFrame = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  init() {
    this._naturalHeight = this.offsetHeight || 0;
    document.body.style.setProperty("--bdt-height-bar", `${this._naturalHeight}px`);
    this.closeButton = this.querySelector(".bdt-aviso-faixa2__encerrar");
    this.parentSection = this.closest(".bdt-faixa-aviso-faixa2");
    if (!this.closeButton || !this.parentSection) return;
    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.onCloseClick.bind(this));
      this.closeButton.addEventListener("keydown", this.onKeyDown.bind(this));
    }
  }

  onKeyDown(bdtv_354c43c1934a) {
    if (bdtv_354c43c1934a.key === "Enter") {
      bdtv_354c43c1934a.preventDefault();
      this.onCloseClick(bdtv_354c43c1934a);
    }
  }

  onCloseClick(bdtv_6e1092fe95c6) {
    bdtv_6e1092fe95c6.preventDefault();
    if (this.isAnimating) return;
    this.isAnimating = true;
    if (!this._naturalHeight || this._naturalHeight <= 0) {
      this._naturalHeight = this.offsetHeight;
    }
    this.parentSection.classList.add("announcement-closing");
    const bdtv_c82b388ae41b = this._naturalHeight;
    const bdtv_8928bc2276ec = performance.now();
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }

    const bdtv_44b17e34af60 = (bdtv_28e77bfda7c5) => {
      const bdtv_1699e6a1c60b = bdtv_28e77bfda7c5 - bdtv_8928bc2276ec;
      const bdtv_8ad4e6fc4a83 = Math.min(bdtv_1699e6a1c60b / this.animationDuration, 1);
      const bdtv_8389c510a71c = this.easeOutCubic(bdtv_8ad4e6fc4a83);
      const bdtv_40dee37c53fc = bdtv_c82b388ae41b * (1 - bdtv_8389c510a71c);
      const bdtv_d5af58e57252 = 1 - bdtv_8389c510a71c;
      this.parentSection.style.height = `${bdtv_40dee37c53fc}px`;
      this.parentSection.style.opacity = String(bdtv_d5af58e57252);
      this.classList.add("bdt-d-ne");
      document.body.style.removeProperty("--bdt-height-bar");
      if (bdtv_8ad4e6fc4a83 < 1) {
        this.animationFrame = requestAnimationFrame(bdtv_44b17e34af60);
      } else {
        this.finishClosingAnimation();
      }
    };
    this.animationFrame = requestAnimationFrame(bdtv_44b17e34af60);
  }

  finishClosingAnimation() {
    this.parentSection.style.height = "0px";
    this.parentSection.style.opacity = "0";
    this.parentSection.classList.remove("announcement-closing");
    this.parentSection.classList.add("announcement-closed");
    bdtv_7d7dfa6f9df7.setCookie("announcement_closed", "true", 1);
    this.isAnimating = false;
  }

  easeOutCubic(bdtv_9d4d9cfac03a) {
    return 1 - Math.pow(1 - bdtv_9d4d9cfac03a, 3);
  }

  disconnectedCallback() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    if (this.closeButton) {
      this.closeButton.removeEventListener("click", this.onCloseClick);
      this.closeButton.removeEventListener("keydown", this.onKeyDown);
    }
  }
}
customElements.define("bdt-aviso-faixa2", bdtv_7ab73785b2c3);

class bdtv_79112f4c8246 extends HTMLElement {
  constructor() {
    super();
    this.addonsUpdate();
  }

  get actionEstimate() {
    return this.querySelector(".bdt-zubi-musu .bdt-timu") || null;
  }

  get cartToggleAddons() {
    return this.querySelector(".bdt-toba-mili") || null;
  }

  get cartActionAddons() {
    return document.querySelector(".bdt-gaveta__sacola-entrega2") || null;
  }

  connectedCallback() {
    if (this.actionEstimate) {
      this.actionEstimate.addEventListener(
        "click",
        this.handleEstimateSave.bind(this)
      );
    }

    if (this.cartActionAddons) {
      this.cartActionAddons.addEventListener(
        "click",
        this.handleEstimateToggle.bind(this)
      );
    }

    if (this.cartToggleAddons) {
      this.cartToggleAddons.addEventListener(
        "click",
        this.handleEstimateToggle.bind(this)
      );
    }
  }

  handleEstimateSave(bdtv_30a5f15a0bd6) {
    bdtv_30a5f15a0bd6.preventDefault();
    const bdtv_9b252a4f0f55 = {
      zip: this.querySelector("#AddressZip").value || "",
      country: this.querySelector("#address_country").value || "",
      province: this.querySelector("#address_province").value || "",
    };
    this.fetchShippingRates(bdtv_9b252a4f0f55);
  }

  fetchShippingRates(bdtv_9cb97564277f) {
    const { zip: bdtv_0a6e96c60eac, country: bdtv_7e549a78cf38, province: bdtv_501893302a7c } = bdtv_9cb97564277f;
    const bdtv_d8bd438beb17 = `${window.Shopify.routes.root}cart/shipping_rates.json?shipping_address%5Bzip%5D=${bdtv_0a6e96c60eac}&shipping_address%5Bcountry%5D=${bdtv_7e549a78cf38}&shipping_address%5Bprovince%5D=${bdtv_501893302a7c}`;
    this.actionEstimate.classList.add("bdt-carregando2");
    fetch(bdtv_d8bd438beb17)
      .then((bdtv_c9512a0e891b) => bdtv_c9512a0e891b.json())
      .then((bdtv_c9affa708b30) => this.updateShippingMessage(bdtv_c9affa708b30, bdtv_9cb97564277f))
      .catch((bdtv_3fe0e5d8c50b) => console.error("Error fetching shipping rates:", bdtv_3fe0e5d8c50b));
  }

  updateShippingMessage(bdtv_1a47620d3357, bdtv_aedd062c5e43) {
    const bdtv_463fb072d018 = this.querySelector(".bdt-zubi-segu");
    bdtv_463fb072d018.innerHTML = "";

    if (bdtv_1a47620d3357 && bdtv_1a47620d3357.shipping_rates) {
      if (bdtv_1a47620d3357?.shipping_rates?.length) {
        this.showShippingSuccess(bdtv_463fb072d018, bdtv_1a47620d3357.shipping_rates, bdtv_aedd062c5e43);
      } else {
        this.showShippingWarning(bdtv_463fb072d018);
      }
    } else {
      this.showShippingError(bdtv_463fb072d018, bdtv_1a47620d3357);
    }
    this.actionEstimate.classList.remove("bdt-carregando2");
  }

  getIconSVG(bdtv_1845bee0a4fe) {
    switch (bdtv_1845bee0a4fe) {
      case "success":
        return '<svg width="18" height="18" fill="none" class="bdt-fi-auto bdt-w-18"><use href="#bdt-simbolo-meda"></use></svg>';
      case "error":
        return '<svg width="18" height="18" fill="none" class="bdt-fi-auto bdt-w-18"><use href="#bdt-simbolo-zuvu"></use></svg>';
      case "warning":
        return '<svg width="18" height="18" fill="none" class="bdt-fi-auto bdt-w-18"><use href="#icon-warning"></use></svg>';
      default:
        return '<svg width="18" height="18" fill="none" class="bdt-fi-auto bdt-w-18"><use href="#bdt-simbolo-meda"></use></svg>';
    }
  }

  showShippingSuccess(bdtv_2a39c92d4d8f, bdtv_d09411eb7365, bdtv_b58b90559f63) {
    bdtv_2a39c92d4d8f.classList.remove("bdt-zuvu", "bdt-daza");
    bdtv_2a39c92d4d8f.classList.add("bdt-meda", "bdt-coluna");

    const bdtv_db99fc2d62e8 = window.cartStrings?.shipping_rate.replace(
      "{{address}}",
      `${bdtv_b58b90559f63.zip}, ${bdtv_b58b90559f63.country} ${bdtv_b58b90559f63.province}`
    );

    bdtv_2a39c92d4d8f.innerHTML =
      `<div class="bdt-fi bdt-corpo-centro2 bdt-vao-sp-2">` +
      this.getIconSVG("success") +
      `<p>${bdtv_db99fc2d62e8}: </p>` +
      `</div>`;

    bdtv_d09411eb7365.forEach((bdtv_fc2f247ad5db) => {
      bdtv_2a39c92d4d8f.innerHTML += `<li>${bdtv_fc2f247ad5db.name}: ${bdtv_7d7dfa6f9df7.formatMoney(
        bdtv_fc2f247ad5db.price,
        bonditRuntimeConfig.settings.money_format
      )}</li>`;
    });
  }

  showShippingWarning(bdtv_5e4d144b576d) {
    bdtv_5e4d144b576d.classList.remove("bdt-zuvu", "bdt-meda", "bdt-coluna");
    bdtv_5e4d144b576d.classList.add("bdt-daza");

    bdtv_5e4d144b576d.innerHTML =
      this.getIconSVG("warning") + `<p>${window.cartStrings?.no_shipping}</p>`;
  }

  showShippingError(bdtv_bc2514ccd300, bdtv_f048e5798ee9) {
    bdtv_bc2514ccd300.classList.remove("bdt-meda", "bdt-daza", "bdt-coluna");
    bdtv_bc2514ccd300.classList.add("bdt-zuvu");

    bdtv_bc2514ccd300.innerHTML =
      this.getIconSVG("error") +
      Object.values(bdtv_f048e5798ee9)
        .map((bdtv_6cbc58b5fbb9) => `<p>${bdtv_6cbc58b5fbb9[0]}</p>`)
        .join("");
  }

  addonsUpdate() {
    const bdtv_df0e14ad30f2 = this.querySelector("#address_country");
    const bdtv_3ef0998ee0b0 = this.querySelector("#address_province");
    if (bdtv_df0e14ad30f2 && bdtv_3ef0998ee0b0) {
      new bdtv_db8d1ea790fe.CountryProvinceSelector(
        "address_country",
        "address_province",
        {
          hideElement: "address_province_container",
        }
      );
    }
  }

  handleEstimateToggle(bdtv_38420634bca3) {
    bdtv_38420634bca3.preventDefault();
    if (this.classList.contains("bdt-aberto2")) {
      this.classList.remove("bdt-aberto2");
      if (this.cartActionAddons) {
        this.cartActionAddons
          .closest(".bdt-gaveta__sacola-entrega2")
          .classList.remove("bdt-ativo2");
      }
      this.cartActionAddons.focus();
    } else {
      this.classList.add("bdt-aberto2");
      if (this.cartActionAddons) {
        this.cartActionAddons
          .closest(".bdt-gaveta__sacola-entrega2")
          .classList.add("bdt-ativo2");
        this.cartToggleAddons.focus();
      }
    }
  }
}

if (!customElements.get("bdt-sacola-timu-riri")) {
  customElements.define("bdt-sacola-timu-riri", bdtv_79112f4c8246);
}

class bdtv_59414e1160c1 extends HTMLElement {
  constructor() {
    super();
  }

  get cartActionId() {
    return this.querySelector(".bdt-aplicar2-zada") || null;
  }

  get cartToggleAddons() {
    return this.querySelector(".bdt-toba-mili") || null;
  }

  get cartActionAddons() {
    return document.querySelector(".bdt-gaveta__sacola-zada") || null;
  }

  connectedCallback() {
    if (this.cartActionId) {
      this.cartActionId.addEventListener(
        "click",
        this.handleNoteSave.bind(this)
      );
    }

    if (this.cartActionAddons) {
      this.cartActionAddons.addEventListener(
        "click",
        this.handleNoteToggle.bind(this)
      );
    }

    if (this.cartToggleAddons) {
      this.cartToggleAddons.addEventListener(
        "click",
        this.handleNoteToggle.bind(this)
      );
    }
  }

  handleNoteSave() {
    this.cartActionId.classList.add("bdt-carregando2");
    this.noteUpdate();
  }

  handleNoteToggle(bdtv_bbc84c6f1e80) {
    bdtv_bbc84c6f1e80.preventDefault();
    if (this.classList.contains("bdt-aberto2")) {
      this.classList.remove("bdt-aberto2");
      if (this.cartActionAddons) {
        this.cartActionAddons
          .closest(".bdt-gaveta__sacola-zada")
          .classList.remove("bdt-ativo2");
      }
      this.cartActionAddons.focus();
    } else {
      this.classList.add("bdt-aberto2");
      if (this.cartActionAddons) {
        this.cartActionAddons
          .closest(".bdt-gaveta__sacola-zada")
          .classList.add("bdt-ativo2");
        this.cartToggleAddons.focus();
      }
    }
  }

  noteUpdate() {
    const bdtv_8c5e435d0960 = JSON.stringify({
      note: this.querySelector(".bdt-sacola-zada").value,
    });
    fetch(`${routes?.cart_update_url}`, {
      ...bdtv_7d7dfa6f9df7.fetchConfig(),
      ...{ body: bdtv_8c5e435d0960 },
    }).finally(() => {
      this.cartActionId.classList.remove("bdt-carregando2");
      this.classList.remove("bdt-aberto2");
      if (this.cartActionAddons) {
        this.cartActionAddons
          .closest(".bdt-gaveta__sacola-zada")
          .classList.remove("bdt-ativo2");
      }
    });
  }
}

if (!customElements.get("bdt-sacola-zada-riri")) {
  customElements.define("bdt-sacola-zada-riri", bdtv_59414e1160c1);
}

class bdtv_78beade4570e extends bdtv_59414e1160c1 {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelector(".bdt-sacola-zada").addEventListener(
      "change",
      this.noteUpdate.bind(this)
    );
  }
}

if (!customElements.get("bdt-central-sacola-zada")) {
  customElements.define("bdt-central-sacola-zada", bdtv_78beade4570e);
}

class bdtv_67c4bcaa3ccb extends HTMLElement {
  constructor() {
    super();
  }

  get type() {
    return this.getAttribute("data-bdt-ga");
  }

  connectedCallback() {
    if (this.type == "auto") {
      fetch(this.dataset.bdtMipo)
        .then((bdtv_73152310985b) => bdtv_73152310985b.text())
        .then((bdtv_06cf01a9ae82) => {
          const bdtv_4f37fc59ff04 = document.createElement("div");
          bdtv_4f37fc59ff04.innerHTML = bdtv_06cf01a9ae82;
          const bdtv_9608a6f7ddff = bdtv_4f37fc59ff04.querySelector(".swiper-wrapper");
          if (!bdtv_9608a6f7ddff) {
            if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
              this.closest(".bdt-gaveta__sacola-sugestoes").classList.add(
                "bdt-oculto2"
              );
            } else {
              this.classList.add("bdt-oculto2");
            }
          }
          if (bdtv_9608a6f7ddff && bdtv_9608a6f7ddff.childElementCount == 0) {
            if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
              this.closest(".bdt-gaveta__sacola-sugestoes").classList.add(
                "bdt-oculto2"
              );
            } else {
              this.classList.add("bdt-oculto2");
            }
          }
          if (
            bdtv_9608a6f7ddff &&
            bdtv_9608a6f7ddff.innerHTML.trim().length &&
            bdtv_9608a6f7ddff.childElementCount > 0
          ) {
            this.querySelector(".swiper-wrapper").innerHTML =
              bdtv_9608a6f7ddff.innerHTML;
            if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
              this.closest(".bdt-gaveta__sacola-sugestoes").classList.remove(
                "bdt-oculto2"
              );
            } else {
              this.classList.remove("bdt-oculto2");
            }
          }
        })
        .finally(() => {})
        .catch((bdtv_60198de12a99) => {
          console.error(bdtv_60198de12a99);
        });
    } else {
      const bdtv_774bd966f592 = this.querySelector(".swiper-wrapper");
      if (!bdtv_774bd966f592) {
        if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
          this.closest(".bdt-gaveta__sacola-sugestoes").classList.add("bdt-oculto2");
        } else {
          this.classList.add("bdt-oculto2");
        }
      }
      if (bdtv_774bd966f592 && bdtv_774bd966f592.childElementCount == 0) {
        if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
          this.closest(".bdt-gaveta__sacola-sugestoes").classList.add("bdt-oculto2");
        } else {
          this.classList.add("bdt-oculto2");
        }
      }
      if (
        bdtv_774bd966f592 &&
        bdtv_774bd966f592.innerHTML.trim().length &&
        bdtv_774bd966f592.childElementCount > 0
      ) {
        this.querySelector(".swiper-wrapper").innerHTML =
          bdtv_774bd966f592.innerHTML;
        if (this.closest(".bdt-gaveta__sacola-sugestoes")) {
          this.closest(".bdt-gaveta__sacola-sugestoes").classList.remove(
            "bdt-oculto2"
          );
        } else {
          this.classList.remove("bdt-oculto2");
        }
      }
    }
  }
}
customElements.define("bdt-vumi-sacola-sugestoes", bdtv_67c4bcaa3ccb);

class bdtv_df2d366de9b2 extends HTMLElement {
  constructor() {
    super();
    this.enable = this.dataset.bdtFoziRoletaPortatil == "true";
    this.isMulticontent = this.dataset.bdtTuse == "true";
    this.isFlexibleSection = this.dataset.bdtSulaFaixa == "true";
    this.showPagination = this.dataset.bdtPiPaginado == "true";
    this.bundle = this.dataset.bdtCombo == "true";
    this.swiperSlideInnerHtml = this.innerHTML;
    this.mobileScreen = Number(this.dataset.bdtPortatilRuke) || 767;
    this.initCarousel();
  }

  initCarousel() {
    if (this.enable) {
      let bdtv_82fa758ef90d = window.innerWidth;
      // Debounce resize event for better performance
      this.debouncedResize = bdtv_7d7dfa6f9df7.debounce(() => {
        const bdtv_4eee434fdccb = window.innerWidth;
        if (bdtv_4eee434fdccb <= this.mobileScreen && bdtv_82fa758ef90d > this.mobileScreen) {
          this.actionOnMobile();
        }
        if (bdtv_4eee434fdccb > this.mobileScreen && bdtv_82fa758ef90d <= this.mobileScreen) {
          this.actionOutMobile();
        }
        bdtv_82fa758ef90d = bdtv_4eee434fdccb;
      }, 250);

      window.addEventListener("resize", this.debouncedResize, {
        passive: true,
      });

      if (bdtv_82fa758ef90d <= this.mobileScreen) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }

  actionOnMobile() {
    this.classList.add("swiper");
    let bdtv_7fce2f4ac990;
    console.log(this.isFlexibleSection);
    if (this.isFlexible) {
      const bdtv_54baa5779885 = document.createElement("div");
      bdtv_54baa5779885.innerHTML = this.swiperSlideInnerHtml;
      const bdtv_1c63ff987c8f = bdtv_54baa5779885.querySelectorAll(":scope > div");
      bdtv_1c63ff987c8f.forEach((bdtv_55379e80c9fa) => {
        if (bdtv_55379e80c9fa.classList.contains("bdt-gufo-lamina__portatil")) {
          bdtv_55379e80c9fa.classList.remove("bdt-gufo-lamina__portatil");
          bdtv_55379e80c9fa.classList.add("swiper-slide");
        }
      });
      bdtv_7fce2f4ac990 = bdtv_54baa5779885.innerHTML;
    } else {
      bdtv_7fce2f4ac990 = this.swiperSlideInnerHtml.replaceAll(
        "bdt-gufo-lamina__portatil",
        "swiper-slide"
      );
    }
    const bdtv_7080daa62f9f = `<div class='swiper-wrapper'>${bdtv_7fce2f4ac990}</div>${this.showPagination
        ? '<div class="swiper-pagination" style="--swiper-pagination-bottom: 0"></div>'
        : ""}`;
    this.innerHTML = bdtv_7080daa62f9f;
    bdtv_c33e4a0d2fca(this);
    new bdtv_c18307a37828(".bdt-figura-zora-no");
  }

  actionOutMobile() {
    new bdtv_c18307a37828(".bdt-figura-zora-no");
    this.classList.remove("swiper");
    this.innerHTML = this.swiperSlideInnerHtml;
    if (this.bundle) {
      this.className = "";
      setTimeout(() => {
        this.classList.remove("swiper-backface-hidden");
      }, 100);
      return;
    }
    new bdtv_c18307a37828(".bdt-figura-zora-no");
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.debouncedResize) {
      window.removeEventListener("resize", this.debouncedResize);
    }
  }
}
customElements.define("bdt-roleta-portatil", bdtv_df2d366de9b2);

class bdtv_f09241980de4 extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    document.body.classList.add("bdt-portatil-fixado-faixa2-kive");
    // Cache site header to avoid repeated queries
    this._siteHeader = document.querySelector(".bdt-soru-topo");
    const bdtv_d81d0fcc51b3 = this._siteHeader.querySelector("header");
    this._dataScroll = bdtv_d81d0fcc51b3.dataset.bdtFixadoGa;
  }

  connectedCallback() {
    // Throttle scroll event for better performance
    this.throttledScroll = bdtv_7d7dfa6f9df7.throttle(
      this.updateScrollNavigationbar.bind(this),
      16
    );
    window.addEventListener("scroll", this.throttledScroll, { passive: true });
  }

  updateScrollNavigationbar() {
    const bdtv_b8a868aa2a3c =
      document.documentElement.scrollTop || document.body.scrollTop;
    const bdtv_1a1c647eedc1 = window.scrollY + window.innerHeight;
    const bdtv_e9aa891fc4e5 = this.offsetHeight;
    const bdtv_87ff2fad83ac = document.body.scrollHeight - bdtv_e9aa891fc4e5 <= bdtv_1a1c647eedc1;
    if (bdtv_87ff2fad83ac) {
      this.classList.add("bdt-pi");
      return;
    }
    if (bdtv_b8a868aa2a3c > 200) {
      if (this._dataScroll == "always") {
        this.classList.add("bdt-pi");
        bdtv_7d7dfa6f9df7.getRoot().classList.add("bdt-portatil-fixado-faixa2-ativo2");
      } else if (
        this._siteHeader &&
        this._siteHeader.classList.contains("bdt-babi") &&
        this._siteHeader.classList.contains("bdt-topo-fixado-oculto2")
      ) {
        this.classList.add("bdt-pi");
        bdtv_7d7dfa6f9df7.getRoot().classList.add("bdt-portatil-fixado-faixa2-ativo2");
      } else if (
        this._siteHeader &&
        this._siteHeader.classList.contains("bdt-babi") &&
        !this._siteHeader.classList.contains("bdt-topo-fixado-oculto2")
      ) {
        this.classList.remove("bdt-pi");
        bdtv_7d7dfa6f9df7.getRoot().classList.remove("bdt-portatil-fixado-faixa2-ativo2");
      } else if (!this._siteHeader) {
        this.classList.add("bdt-pi");
        bdtv_7d7dfa6f9df7.getRoot().classList.add("bdt-portatil-fixado-faixa2-ativo2");
      } else {
        this.classList.add("bdt-pi");
        bdtv_7d7dfa6f9df7.getRoot().classList.add("bdt-portatil-fixado-faixa2-ativo2");
      }
    } else {
      this.classList.remove("bdt-pi");
      bdtv_7d7dfa6f9df7.getRoot().classList.remove("bdt-portatil-fixado-faixa2-ativo2");
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.throttledScroll) {
      window.removeEventListener("scroll", this.throttledScroll);
    }
    // Clear cached elements
    this._siteHeader = null;
  }
}
customElements.define("bdt-portatil-roteiro-faixa2", bdtv_f09241980de4);

var bdtv_bff9340675cb = (function () {
  return {
    init: function () {
      this.toggleForm(), this.deleteAddresses(), this.addAddresses();
    },
    toggleForm: function () {
      const bdtv_63d37e0ed93d = document.querySelector(".bdt-juntar-endereco2");
      const bdtv_b8b13e469189 = document.querySelector(".bdt-rali-juntar");
      if (bdtv_63d37e0ed93d !== null && bdtv_b8b13e469189 !== null) {
        bdtv_63d37e0ed93d.addEventListener("click", () => {
          if (bdtv_63d37e0ed93d.getAttribute("aria-expanded") === "false") {
            bdtv_63d37e0ed93d.setAttribute("aria-expanded", "true");
            bdtv_63d37e0ed93d.closest(".bdt-so-cliente2__endereco2").classList.add("bdt-ativo2");
          } else {
            bdtv_63d37e0ed93d.setAttribute("aria-expanded", "false");
            bdtv_63d37e0ed93d.closest(".bdt-so-cliente2__endereco2").classList.remove("bdt-ativo2");
          }
        });
        bdtv_b8b13e469189.addEventListener("click", () => {
          if (
            bdtv_b8b13e469189.closest(".bdt-so-cliente2__endereco2").classList.contains("bdt-ativo2")
          ) {
            bdtv_63d37e0ed93d.closest(".bdt-so-cliente2__endereco2").classList.remove("bdt-ativo2");
            bdtv_63d37e0ed93d.closest(".bdt-juntar-endereco2").setAttribute("aria-expanded", "false");
          }
        });
      }
    },
    deleteAddresses: function () {
      const bdtv_a8d7fc9737d8 = document.querySelectorAll(".bdt-endereco2-kaki");
      bdtv_a8d7fc9737d8.forEach((bdtv_5e5a6e23143c) => {
        bdtv_5e5a6e23143c.addEventListener("click", () => {
          const bdtv_eb1125caa971 = bdtv_5e5a6e23143c?.dataset.bdtFormulario2Vopa;
          const bdtv_68798c2694bf = bdtv_5e5a6e23143c?.dataset.bdtTuboSegu;
          if (confirm(bdtv_68798c2694bf || "Are you sure you wish to delete this address?")) {
            bdtv_db8d1ea790fe.postLink("/account/addresses/" + bdtv_eb1125caa971, {
              parameters: { _method: "delete" },
            });
          }
        });
      });
    },
    addAddresses: function () {
      if (bdtv_db8d1ea790fe && document.getElementById("AddressCountryNew")) {
        new bdtv_db8d1ea790fe.CountryProvinceSelector(
          "AddressCountryNew",
          "AddressProvinceNew",
          {
            hideElement: "AddressProvinceNewContainer",
          }
        );
      }
      const bdtv_eccdbc76edba = document.querySelectorAll(".bdt-gi-pais2-escolha");
      bdtv_eccdbc76edba.forEach((bdtv_3658cbcb222b) => {
        const bdtv_446832a06263 = bdtv_3658cbcb222b?.dataset.bdtFormulario2Vopa;
        const bdtv_d68e7e7c7671 = "AddressCountry_" + bdtv_446832a06263;
        const bdtv_a05f64b5d399 = "AddressProvince_" + bdtv_446832a06263;
        const bdtv_e216183cb50b = "AddressProvinceContainer_" + bdtv_446832a06263;
        new bdtv_db8d1ea790fe.CountryProvinceSelector(bdtv_d68e7e7c7671, bdtv_a05f64b5d399, {
          hideElement: bdtv_e216183cb50b,
        });
      });
    },
  };
})();
bdtv_bff9340675cb.init();
class bdtv_51b8f888df09 extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.slider = this.querySelector(".bdt-trilho");
    this.overlay = this.querySelector(".bdt-figura-depois2");
    this.handle = this.querySelector(".bdt-nama");
    this.x = 0;
    this.boundary = 300;
    this.mixClipPath;
    this.mixSliderColor;
    this.step = 50;
    this.elastic = 0.1;
    this.animated = false;
    this.observer = null;

    this.isHovering = false;

    this.init();
    this.setupDrag();

    this.handleResize = this.handleResize.bind(this);

    this.slider.addEventListener("focus", () => {
      document.addEventListener("keydown", this.handleKeyDown.bind(this));
    });

    this.slider.addEventListener("blur", () => {
      document.removeEventListener("keydown", this.handleKeyDown.bind(this));
    });

    window.addEventListener("resize", this.handleResize);

    window.addEventListener("orientationchange", () => {
      setTimeout(() => this.handleResize(), 200);
    });

    this.setupIntersectionObserver();
  }

  updateSliderStatus() {
    const bdtv_34844200b23b = this.closest("bdt-lamina-faixa");
    if (!bdtv_34844200b23b) return;

    const bdtv_5355fb8fc4cf = bdtv_34844200b23b.swiper;
    if (!bdtv_5355fb8fc4cf) return;

    bdtv_5355fb8fc4cf.allowTouchMove = !this.isHovering;

    if (this.isHovering) {
      bdtv_5355fb8fc4cf.allowSlideNext = false;
      bdtv_5355fb8fc4cf.allowSlidePrev = false;
    } else {
      bdtv_5355fb8fc4cf.allowSlideNext = true;
      bdtv_5355fb8fc4cf.allowSlidePrev = true;
    }
    bdtv_5355fb8fc4cf.update();
  }

  handleResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(() => {
      const bdtv_5da2ae23aea4 = this.container.clientWidth;
      const bdtv_5f1da52b8932 = bdtv_5da2ae23aea4 / 2;

      if (
        !this.fullBoundary ||
        Math.abs(this.fullBoundary - bdtv_5f1da52b8932) > 5
      ) {
        this.init();
        this.moveSlider(0);
      }
    }, 100);
  }

  init() {
    const bdtv_0378dc7655ca = this.handle ? this.handle.offsetWidth : 0;
    this.fullBoundary = this.container.clientWidth / 2;

    const bdtv_ee7fd4908735 = 1;
    this.boundary = this.fullBoundary - bdtv_0378dc7655ca / 2 + bdtv_ee7fd4908735;

    this.mixClipPath = Motion.transform(
      [-this.fullBoundary, this.fullBoundary],
      ["inset(0% 0% 0% 0%)", "inset(0% 0% 0% 100%)"]
    );

    this.mixSliderColor = Motion.transform(
      [
        -this.boundary + 20,
        -this.boundary + 60,
        this.boundary - 60,
        this.boundary - 20,
      ],
      [
        "rgba(255, 255, 255)",
        "rgba(255, 255, 255)",
        "rgba(255, 255, 255)",
        "rgba(255, 255, 255)",
      ]
    );

    if (!this.animated) {
      const bdtv_1396c9cecbb9 = -this.boundary + this.boundary * 0.2;
      this.moveSlider(bdtv_1396c9cecbb9);
    } else {
      this.moveSlider(0);
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (bdtv_08c3c55f9f1e) => {
        bdtv_08c3c55f9f1e.forEach((bdtv_163d6a9b67b3) => {
          if (bdtv_163d6a9b67b3.isIntersecting && !this.animated) {
            this.runEntranceAnimation();
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.2,
      }
    );
    this.observer.observe(this);
  }

  runEntranceAnimation() {
    this.animated = true;
    const bdtv_29eb74c82b41 = -this.boundary + this.boundary * 0.2;
    Motion.animate(bdtv_29eb74c82b41, 0, {
      onUpdate: (bdtv_0faed0d37331) => this.moveSlider(bdtv_0faed0d37331),
      type: "spring",
      stiffness: 80,
      damping: 20,
      duration: 0.8,
      delay: 0.2,
    });
  }

  moveSlider(bdtv_6819d6ae6e26) {
    this.x = bdtv_6819d6ae6e26;
    const bdtv_bc5351bb1aee = Motion.clamp(-this.fullBoundary, this.fullBoundary, bdtv_6819d6ae6e26);
    this.overlay.style.clipPath = this.mixClipPath(bdtv_bc5351bb1aee);
    this.slider.style.transform = `translateX(${this.x}px)`;
    this.slider.style.backgroundColor = this.mixSliderColor(this.x);
  }

  handleKeyDown(bdtv_b318a6226b5f) {
    if (!this.slider.matches(":focus")) return;
    let bdtv_c40f512bec86 = 0;

    if (bdtv_b318a6226b5f.key === "ArrowLeft") {
      bdtv_c40f512bec86 = -this.step;
    } else if (bdtv_b318a6226b5f.key === "ArrowRight") {
      bdtv_c40f512bec86 = this.step;
    } else {
      return;
    }

    Motion.animate(
      this.x,
      Motion.clamp(-this.boundary, this.boundary, this.x + bdtv_c40f512bec86),
      {
        onUpdate: (bdtv_0fc44f6c55e4) => this.moveSlider(bdtv_0fc44f6c55e4),
        type: "spring",
        stiffness: 900,
        damping: 40,
        velocity: bdtv_c40f512bec86 * 10,
      }
    );
  }

  setupDrag() {
    let bdtv_e27eab2f0aee = 0;
    let bdtv_f7595a86df5a = 0;
    let bdtv_9f25697b7d01 = 0;
    let bdtv_4c3542c738af = false;
    let bdtv_0c39e4a480e2 = 0;
    const bdtv_be4bbba6d469 = this;
    function bdtv_8e195e54bad0() {
      bdtv_be4bbba6d469.moveSlider(bdtv_9f25697b7d01);
    }

    this.slider.addEventListener("pointerdown", (bdtv_a89bda5e68c4) => {
      bdtv_e27eab2f0aee = this.x;
      bdtv_f7595a86df5a = bdtv_a89bda5e68c4.clientX;
      bdtv_4c3542c738af = true;
      bdtv_0c39e4a480e2 = this.fullBoundary;
      document.body.style.cursor = "grabbing";
      this.slider.style.cursor = "grabbing";
      this.slider.classList.add("bdt-ativo2");
      this.slider.setPointerCapture(bdtv_a89bda5e68c4.pointerId);
      this.isHovering = true;
      this.updateSliderStatus();
    });

    this.slider.addEventListener("pointermove", (bdtv_bb9cad6c9f2d) => {
      if (!this.slider.hasPointerCapture(bdtv_bb9cad6c9f2d.pointerId) || !bdtv_4c3542c738af) return;

      const bdtv_009c39d5bb0d = bdtv_bb9cad6c9f2d.clientX - bdtv_f7595a86df5a;
      bdtv_9f25697b7d01 = bdtv_e27eab2f0aee + bdtv_009c39d5bb0d;

      const bdtv_b16cfd7555ea = this.handle ? this.handle.offsetWidth : 0;
      const bdtv_245e03996c43 = 1;
      const bdtv_9f70b133aa29 = bdtv_0c39e4a480e2 - bdtv_b16cfd7555ea / 2;
      const bdtv_d6967484f06b = -bdtv_0c39e4a480e2 + bdtv_b16cfd7555ea / 2 - bdtv_245e03996c43;
      bdtv_9f25697b7d01 = Motion.clamp(bdtv_d6967484f06b, bdtv_9f70b133aa29, bdtv_9f25697b7d01);
      Motion.frame.render(bdtv_8e195e54bad0);
    });

    this.slider.addEventListener("pointerup", (bdtv_085218e89b08) => {
      if (!this.slider.hasPointerCapture(bdtv_085218e89b08.pointerId)) return;
      this.slider.releasePointerCapture(bdtv_085218e89b08.pointerId);
      bdtv_4c3542c738af = false;
      document.body.style.cursor = "default";
      this.slider.style.cursor = "grab";
      this.slider.classList.remove("bdt-ativo2");
      if (this.x < -this.boundary || this.x > this.boundary) {
        const bdtv_fe2b5988d4ed =
          this.x < -this.boundary ? -this.boundary : this.boundary;
        Motion.animate(this.x, bdtv_fe2b5988d4ed, {
          onUpdate: (bdtv_07b417b71601) => this.moveSlider(bdtv_07b417b71601),
          type: "spring",
          stiffness: 900,
          damping: 40,
        });
      }
      this.isHovering = false;
      this.updateSliderStatus();
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize);
    document.removeEventListener("keydown", this.handleKeyDown);

    this.removeEventListener("mouseenter", null);
    this.removeEventListener("mouseleave", null);
    this.removeEventListener("touchstart", null);
    this.removeEventListener("touchend", null);
  }
}
customElements.define("bdt-figura-supe", bdtv_51b8f888df09);

class bdtv_c41a54ccd65c extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this), false);

    const bdtv_b4ad8c48c0f6 = window.location.href;
    const bdtv_8f774e2476e7 = location.href.split("?")[0];
    if (bdtv_b4ad8c48c0f6.indexOf("contact_posted=true#ContactFormAsk") >= 1) {
      bdtv_86c1642f965f.show(message.ask_question.success, "success", 4000);
      window.history.pushState("object", document.title, bdtv_8f774e2476e7);
    }
  }
  onClick(bdtv_43873a830e2d) {
    const bdtv_a70657726ae3 = bdtv_43873a830e2d.target
      .closest(".bdt-mifa-pergunta2")
      .querySelector("template");
    if (bdtv_a70657726ae3) {
      const bdtv_8d4c026288e9 = document.createElement("div");
      bdtv_8d4c026288e9.appendChild(
        bdtv_a70657726ae3.content.firstElementChild.cloneNode(true)
      );
      bdtv_7d7dfa6f9df7.getBody().appendChild(
        bdtv_8d4c026288e9.querySelector("bdt-mifa-pergunta2-balao")
      );
    }
    setTimeout(
      () =>
        bdtv_e7813df41f5c(document.querySelector("bdt-mifa-pergunta2-balao"), "open", true),
      100
    );
    bdtv_7d7dfa6f9df7.global.rootToFocus = this;
  }
}
customElements.define("bdt-mifa-pergunta2", bdtv_c41a54ccd65c, {
  extends: "button",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-mifa-pergunta2": {
    tagElement: "button",
    classElement: bdtv_c41a54ccd65c,
  },
});
class bdtv_37858a1f606a extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.querySelectorAll(".bdt-diario-tegu .bdt-le-sharing").forEach((bdtv_a6d5fc28ddaa) => {
      bdtv_a6d5fc28ddaa.addEventListener(
        "click",
        (bdtv_24b328d21a88) => {
          bdtv_24b328d21a88.preventDefault();
          const bdtv_8531d9136dca = bdtv_24b328d21a88.currentTarget;
          const bdtv_c1829664e70b = bdtv_8531d9136dca.getAttribute("data-bdt-redes");
          const bdtv_d2321f599342 = bdtv_8531d9136dca.getAttribute("data-bdt-fa");
          window.open(bdtv_c1829664e70b, bdtv_d2321f599342, "height=500,width=500");
        },
        false
      );
    });
  }
}
customElements.define("bdt-redes-partilha", bdtv_37858a1f606a);

class bdtv_9649e1f8e9d5 extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    if (this.querySelector("template")) {
      const bdtv_18a40b384ce5 = async (bdtv_534b9b6fffc1, bdtv_4d08f23e2963) => {
        if (!bdtv_534b9b6fffc1[0].isIntersecting) return;
        bdtv_4d08f23e2963.unobserve(this);
        const bdtv_304452a796b2 = document.createElement("div");
        bdtv_304452a796b2.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          )
        );
        const bdtv_ed72305614fa = bdtv_304452a796b2.querySelector(".bdt-artigo__mifu")
          ? bdtv_304452a796b2.querySelector(".bdt-artigo__mifu")
          : bdtv_304452a796b2.querySelector(".bdt-puso");
        await import(importJs.countdownTimer);
        this.parentNode.insertBefore(bdtv_ed72305614fa, this.nextSibling);
        this.remove();
      };
      new IntersectionObserver(bdtv_18a40b384ce5.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }
}
customElements.define("bdt-zora-no-zovi", bdtv_9649e1f8e9d5);

class bdtv_69603e7e7822 extends HTMLElement {
  constructor() {
    super(),
      this.contents.forEach((bdtv_4fa0e19f1fef) => {
        const bdtv_88546c6c5735 =
          bdtv_4fa0e19f1fef.querySelector(".bdt-peca__cabeca") ||
          bdtv_4fa0e19f1fef.querySelector(".bdt-peca__relato") ||
          bdtv_4fa0e19f1fef.querySelector(".bdt-peca__vigu");
        Motion.scroll(
          Motion.animate(bdtv_88546c6c5735, {
            opacity: [0, 0, 1, 1, 1, 0, 0],
          }),
          {
            target: bdtv_88546c6c5735,
            offsets: ["33vh", "66vh"],
          }
        );
      });
  }

  get contents() {
    return Array.from(this.children);
  }
}
customElements.define("bdt-rolando-efeito2", bdtv_69603e7e7822);
class bdtv_2ba9784abbad extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      (this.initAnimate(),
      Motion.inView(
        this,
        async () => {
          this.mediaElements && (await bdtv_a771d8d107da(this.mediaElements)),
            setTimeout(() => {
              this.initAnimateEffect();
            }, 100);
        },
        {
          margin: this.animationConfig.rayo.margin,
        }
      ));
  }

  get scrollAnimation() {
    return bonditRuntimeConfig.settings.scrollAnimation;
  }

  get slideShowElements() {
    return this.hasAttribute("slideshow") ? true : false;
  }

  get mediaElements() {
    return this.querySelectorAll("img, svg");
  }

  get animateEffect() {
    return this.dataset.bdtBabi || "";
  }

  get delay() {
    return parseInt(this.dataset.bdtBabiSete || 0) / 1000;
  }

  getMediaElement() {
    return this.querySelector("img");
  }

  getPlaceholderElement() {
    return this.querySelector("svg");
  }

  getMedia() {
    return this.getMediaElement() !== null
      ? this.getMediaElement()
      : this.getPlaceholderElement();
  }

  get delayLoad() {
    return this.classList.contains("animate-delay");
  }

  get delayMedia() {
    return this.closest(".bdt-peca__peca2-mostruario")
      ? this.closest(".bdt-peca__peca2-mostruario").classList.contains("bdt-febo")
      : false;
  }

  get animationConfig() {
    return {
      slideInLeft: {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.8,
        easing: [0.422, 0.117, 0.572, 0.786],
      },
      rayo: {
        ease: [0.22, 0.61, 0.36, 1],
        dIn: 0.8,
        dOut: 0.65,
        margin: "0px 0px -30px 0px",
        upY: 25,
        zx: 0,
        zy: 0,
        zScale: 1.06,
      },
      motion: {
        easing: [0.22, 0.61, 0.36, 1],
        dIn: 1.1,
        dOut: 0.7,
      },
    };
  }

  initAnimate() {
    if (
      this.scrollAnimation == "desktop_only" &&
      window.innerWidth < 768 &&
      !this.slideShowElements
    ) {
      return;
    }
    if (this.delayMedia) {
      return;
    }
    switch (this.animateEffect) {
      case "bdt-vite-verbo":
        this.highlightedTextInitial();
        break;
      case "left-to-right":
        this.leftToRightInitial();
        break;
      case "fade-in":
        this.fadeInInitial();
        break;
      case "fade-up":
        this.fadeUpInitial();
        break;
      case "zoom-in":
        this.zoomInInitial();
        break;
      case "zoom-in-big":
        this.zoomInBigInitial();
        break;
      case "zoom-out":
        this.zoomOutInitial();
        break;
      case "zoom-out-small":
        this.zoomOutSmallInitial();
        break;
      case "slide-in-left":
        this.slideInLeftInitial();
        break;
    }
  }

  leftToRightInitial() {
    Motion.animate(this, { opacity: 0 }, { duration: 0 });
  }

  fadeInInitial() {
    Motion.animate(this, { opacity: 0 }, { duration: 0 });
  }

  highlightedTextInitial() {
    this.animateSvgInitial();
  }

  fadeUpInitial() {
    this.style.willChange = "transform, opacity";
    Motion.animate(
      this,
      {
        transform: `translateY(${this.animationConfig.rayo.upY}px)`,
        opacity: 0,
      },
      { duration: 0 }
    );

    this._reverseToInitial = () => {
      Motion.animate(
        this,
        {
          transform: `translateY(${this.animationConfig.rayo.upY}px)`,
          opacity: 0,
        },
        {
          duration: this.animationConfig.rayo.dOut,
          easing: this.animationConfig.rayo.ease,
        }
      );
    };
    this.animateSvgInitial();
  }

  zoomInInitial() {
    Motion.animate(this, { transform: "scale(0.8)" }, { duration: 0 });
  }

  zoomInBigInitial() {
    Motion.animate(this, { transform: "scale(0)" }, { duration: 0 });
  }

  zoomOutSmallInitial() {
    if (window.innerWidth < 768) return;
    Motion.animate(
      this,
      {
        transform: `translate(${this.animationConfig.rayo.zx}px, ${this.animationConfig.rayo.zy}px) scale(${this.animationConfig.rayo.zScale})`,
      },
      { duration: 0 }
    );
  }
  zoomOutInitial() {
    if (window.innerWidth < 768) return;
    Motion.animate(
      this,
      { transform: "scale(1.1)", opacity: 1 },
      { duration: 0 }
    );
  }
  slideInLeftInitial() {
    Motion.animate(
      this,
      {
        clipPath: "inset(0% 100% 0% 0%)",
      },
      { duration: 0 }
    );
  }

  async initAnimateEffect() {
    if (
      this.scrollAnimation == "desktop_only" &&
      window.innerWidth < 768 &&
      !this.slideShowElements
    )
      return;

    if (this.delayMedia || this.delayLoad) return;

    switch (this.animateEffect) {
      case "bdt-vite-verbo":
        await this.highlightedText();
        break;
      case "fade-up":
        await this.fadeUp();
        break;
      case "zoom-out-small":
        await this.zoomOutSmall();
        break;
      case "left-to-right":
        this.leftToRight();
        break;
      case "fade-in":
        await this.fadeIn();
        break;
      case "zoom-in":
        await this.zoomIn();
        break;
      case "zoom-in-big":
        await this.zoomInBig();
        break;
      case "zoom-out":
        await this.zoomOut();
        break;
      case "slide-in-left":
        this.slideInLeft();
        break;
    }
    if (this.slideShowElements) {
      this.classList.add("animate-delay");
    }
  }

  async highlightedText() {
    await this.animateSvg();
  }

  async fadeUp() {
    await Motion.animate(
      this,
      { transform: "translateY(0px)", opacity: 1 },
      {
        duration: 0.5,
        delay: this.delay || 0,
        easing: this.animationConfig.rayo.ease,
      }
    ).finished;
    this.animateSvg();
  }

  async leftToRight() {
    await Motion.animate(this, { opacity: 1 }).finished;
    this.classList.add("bdt-pi");
  }

  async fadeIn() {
    await Motion.animate(
      this,
      { opacity: 1 },
      {
        duration: 0.4,
        delay: this.delay,
        easing: this.animationConfig.motion.easing,
      }
    ).finished;
  }

  async zoomIn() {
    await Motion.animate(
      this,
      { transform: "scale(1)" },
      {
        duration: this.animationConfig.motion.dIn,
        delay: this.delay,
        easing: this.animationConfig.motion.easing,
      }
    ).finished;
  }

  async zoomInBig() {
    await Motion.animate(
      this,
      { transform: "scale(1)" },
      {
        duration: this.animationConfig.motion.dIn,
        delay: this.delay,
        easing: this.animationConfig.motion.easing,
      }
    ).finished;
  }

  async zoomOut() {
    if (window.innerWidth < 768) return;
    await Motion.animate(
      this,
      { transform: "scale(1)" },
      {
        duration: this.animationConfig.motion.dIn,
        delay: this.delay,
        easing: this.animationConfig.motion.easing,
      }
    ).finished;
  }

  async zoomOutSmall() {
    if (window.innerWidth < 768) return;
    Motion.animate(
      this,
      {
        transform: [
          `translate(${this.animationConfig.rayo.zx}px, ${this.animationConfig.rayo.zy}px) scale(${this.animationConfig.rayo.zScale})`,
          "translate(0px, 0px) scale(1)",
        ],
      },
      {
        duration: this.animationConfig.rayo.dIn,
        delay: this.delay || 0,
        easing: this.animationConfig.rayo.ease,
      }
    ).finished;
  }

  async slideInLeft() {
    Motion.animate(
      this.getMedia(),
      {
        clipPath: this.animationConfig.slideInLeft.clipPath,
      },
      {
        duration: this.animationConfig.slideInLeft.duration,
        easing: this.animationConfig.slideInLeft.easing,
        delay: this.delay,
      }
    ).finished;
  }

  animateSvgInitial() {
    const bdtv_a43dc09e3755 = this.querySelectorAll("svg");
    bdtv_a43dc09e3755.forEach((bdtv_a8183b8bc3f4) => {
      bdtv_a8183b8bc3f4.classList.remove("bdt-babi");
    });
  }

  animateSvg() {
    const bdtv_e7e38ca1b860 = this.querySelectorAll("svg");
    bdtv_e7e38ca1b860.forEach((bdtv_ae32388b1610) => {
      bdtv_ae32388b1610.classList.add("bdt-babi");
    });
  }
}
customElements.define("bdt-rari-efeito2", bdtv_2ba9784abbad);
class bdtv_15d9ef04b7ac extends HTMLElement {
  constructor() {
    super();
    this.setupInitialAnimation();
    this.setupInViewEffect();
  }

  get scrollAnimation() {
    return bonditRuntimeConfig.settings.scrollAnimation;
  }

  get allItems() {
    return this.querySelectorAll(".bdt-rari-unidade");
  }

  get visibleItems() {
    return this.querySelectorAll(".bdt-artigo-item:not([style])");
  }

  setupInitialAnimation() {
    if (this.scrollAnimation == "desktop_only" && window.innerWidth < 768) {
      return;
    }
    Motion.animate(
      this.allItems,
      {
        y: 30,
        opacity: 0,
        visibility: "hidden",
      },
      {
        duration: 0,
      }
    );
  }

  setupInViewEffect() {
    if (this.scrollAnimation == "desktop_only" && window.innerWidth < 768) {
      return;
    }
    Motion.inView(this, this.animateItems.bind(this), {
      margin: "0px 0px -50px 0px",
    });
  }

  animateItems() {
    Motion.animate(
      this.allItems,
      {
        y: [30, 0],
        opacity: [0, 1],
        visibility: ["hidden", "visible"],
      },
      {
        duration: 0.5,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    ).finished;
  }

  reloadAnimationEffect() {
    if (this.scrollAnimation == "desktop_only" && window.innerWidth < 768) {
      return;
    }
    Motion.animate(
      this.visibleItems,
      {
        y: [30, 0],
        opacity: [0, 1],
        visibility: ["hidden", "visible"],
      },
      {
        duration: 0.5,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    ).finished;
  }
}
customElements.define("bdt-rari-gali-efeito2", bdtv_15d9ef04b7ac);

class bdtv_9bff9911c5c2 extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this), false);
  }
  onClick() {
    const bdtv_5d3e37a05443 = this.getAttribute("data-bdt-boke");
    navigator.clipboard.writeText(bdtv_5d3e37a05443);
    bdtv_86c1642f965f.show(window.message.socialCopyLink.success, "success");
  }
}
customElements.define("bdt-gatilho-duplicar2-atalho", bdtv_9bff9911c5c2, {
  extends: "button",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-gatilho-duplicar2-atalho": {
    tagElement: "button",
    classElement: bdtv_9bff9911c5c2,
  },
});

class bdtv_adbd76ac3954 extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }

  get sectionId() {
    return document.querySelector("bdt-liba-gaveta")
      ? document
          .querySelector("bdt-liba-gaveta")
          .getAttribute("data-bdt-faixa-vopa")
      : null;
  }

  init() {
    this.addEventListener("click", this.onClick.bind(this), false);
    this.addEventListener(
      "keypress",
      function (bdtv_ca0cf14827be) {
        if (bdtv_ca0cf14827be.key === "Enter") {
          this.onClick.bind(this)(bdtv_ca0cf14827be);
        }
      }.bind(this),
      false
    );
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:select", (bdtv_6e05f7c057a1) => {
        const bdtv_e1eb64f28956 = bdtv_6e05f7c057a1.target;
        if (
          JSON.parse(bdtv_e1eb64f28956.dataset.shopifyEditorSection).id ===
          this.sectionId
        ) {
          const bdtv_d38589ead6ec = document.querySelector("bdt-liba-gaveta");
          bdtv_e7813df41f5c(bdtv_d38589ead6ec, "open", false, "delay", true);
        }
      }),
      document.addEventListener("shopify:section:deselect", () => {
        const bdtv_63c5058d3e89 = document.querySelector("bdt-liba-gaveta");
        if (bdtv_63c5058d3e89) {
          bdtv_e7813df41f5c(bdtv_63c5058d3e89, "close", false);
        }
      }));
  }

  async onClick(bdtv_86de788d7e41) {
    bdtv_86de788d7e41.preventDefault();
    if (this.dataset.bdtMipo) {
      this.setAttribute("aria-disabled", true);
      this.classList.add("bdt-carregando2");
      if (!this.sectionId) {
        window.location.href = this.dataset.bdtMipo;
        return;
      }
      await (import(importJs.mediaGallery), import(importJs.productModel));
      this.fetchUrl();
    }
  }

  fetchUrl() {
    fetch(`${this.dataset.bdtMipo}?section_id=${this.sectionId}`)
      .then((bdtv_4284bc46a416) => bdtv_4284bc46a416.text())
      .then((bdtv_47258ede7698) => {
        const bdtv_060b47d12742 = bdtv_7d7dfa6f9df7.parser.parseFromString(bdtv_47258ede7698, "text/html");
        document.querySelector(".bdt-liba-artigo").innerHTML =
          bdtv_060b47d12742.querySelector(".bdt-liba-artigo").innerHTML;
      })
      .finally(async () => {
        this.classList.remove("bdt-carregando2");
        this.removeAttribute("aria-disabled");
        const bdtv_48d570ef6acd = document.querySelector("bdt-liba-gaveta");
        const bdtv_9e5075b98875 = document.querySelector("bdt-antes2-bute-bifi.bdt-ativo2"
        );
        if (bdtv_9e5075b98875) {
          bdtv_e7813df41f5c(bdtv_9e5075b98875, "close", false);
          if (bdtv_7d7dfa6f9df7.setCookie) {
            bdtv_7d7dfa6f9df7.setCookie("before_you_leave_hidden", "true", 1);
          }
        }
        bdtv_e7813df41f5c(bdtv_48d570ef6acd, "open", false, "delay", true);
        bdtv_7d7dfa6f9df7.global.rootToFocus = this;
        new bdtv_c18307a37828(".bdt-figura-zora-no");
        await (import(importJs.mediaLightboxGallery),
        import(importJs.countdownTimer),
        import(importJs.recipientForm));
        bdtv_48d570ef6acd.querySelector(".bdt-janela-nucleo").scrollTop = 0;
      })
      .catch((bdtv_53b3781bf492) => {
        console.error(bdtv_53b3781bf492);
      });
  }
}
customElements.define("bdt-gatilho-muku-vista", bdtv_adbd76ac3954, {
  extends: "button",
});
bdtv_bc7688b00aa5.observeAndPatchCustomElements({
  "bdt-gatilho-muku-vista": {
    tagElement: "button",
    classElement: bdtv_adbd76ac3954,
  },
});

class bdtv_0848caf026cb extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const bdtv_bf42548a91e3 = this.getAttribute("text");
    if (bdtv_bf42548a91e3) {
      const bdtv_52776c55dc8d = bdtv_bf42548a91e3.split(",").map((bdtv_a79b3935df8c) => bdtv_a79b3935df8c.trim());
      const bdtv_e5a369d90083 = this.closest(".bdt-campo2-contato2-nufe"
      ).querySelector("select");
      bdtv_52776c55dc8d.forEach((bdtv_91d5c0250f3a) => {
        const bdtv_a62de09423e3 = document.createElement("option");
        bdtv_a62de09423e3.value = bdtv_91d5c0250f3a.toLowerCase();
        bdtv_a62de09423e3.textContent =
          bdtv_91d5c0250f3a.charAt(0).toUpperCase() + bdtv_91d5c0250f3a.slice(1);
        bdtv_e5a369d90083.appendChild(bdtv_a62de09423e3);
      });
    }
  }
}
customElements.define("bdt-seletor2-contato2", bdtv_0848caf026cb);

class bdtv_83ce70e31ec0 extends HTMLElement {
  constructor() {
    super();
    this.delay = parseInt(this.dataset.bdtHora2Sete, 10);
    this.sectionId = this.dataset.bdtFaixaVopa;
    this.interactions = 0;
    this.popupActive = false;
    this.cookieName = "before_you_leave_hidden";
    this.closeHandler = this.closeHandler.bind(this);
    if (
      bdtv_7d7dfa6f9df7.getCookie &&
      bdtv_7d7dfa6f9df7.getCookie(this.cookieName) === "true"
    ) {
      return;
    }
    if (!window.Shopify.designMode) {
      setTimeout(() => this.init(), 100);
    }
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:select", (bdtv_d9e979cfcf5a) => {
        const bdtv_95e06450d141 = bdtv_d9e979cfcf5a.target;
        if (
          JSON.parse(bdtv_95e06450d141.dataset.shopifyEditorSection).id ===
          this.sectionId
        ) {
          bdtv_e7813df41f5c(this, "open", false);
          this.bindCouponCopy();
        }
      }),
      document.addEventListener("shopify:section:deselect", () => {
        const bdtv_d5240b703d15 = document.querySelector("bdt-antes2-bute-bifi");
        if (bdtv_d5240b703d15) {
          bdtv_e7813df41f5c(bdtv_d5240b703d15, "close", false);
        }
      }));
  }

  init() {
    if (
      bdtv_7d7dfa6f9df7.getCookie &&
      bdtv_7d7dfa6f9df7.getCookie(this.cookieName) === "true"
    ) {
      return;
    }
    const bdtv_02830a340e6d = document.getElementById(this.sectionId);
    if (!bdtv_02830a340e6d) {
      return;
    }
    this.innerHTML = bdtv_02830a340e6d.innerHTML;
    if (typeof BlsLazyloadImg !== "undefined") {
      BlsLazyloadImg.init();
    }
    this.initPopup();
  }

  initPopup() {
    if (
      bdtv_7d7dfa6f9df7.getCookie &&
      bdtv_7d7dfa6f9df7.getCookie(this.cookieName) === "true"
    ) {
      return;
    }
    if (this._inactivityInitialized) return;
    this._inactivityInitialized = true;
    this._inactivityTimer = null;
    this._inactivityTriggered = false;
    const bdtv_f298e568d1cc = ["scroll", "click", "mousemove", "keydown"];
    const bdtv_088f96dbbe07 = this;
    function bdtv_1f494ac10d1c() {
      if (bdtv_088f96dbbe07._inactivityTimer) clearTimeout(bdtv_088f96dbbe07._inactivityTimer);
      if (bdtv_088f96dbbe07._inactivityTriggered) return;
      bdtv_088f96dbbe07._inactivityTimer = setTimeout(() => {
        if (!bdtv_088f96dbbe07._inactivityTriggered) {
          bdtv_088f96dbbe07._inactivityTriggered = true;
          if (bdtv_088f96dbbe07._inactivityTimer) {
            clearTimeout(bdtv_088f96dbbe07._inactivityTimer);
            bdtv_088f96dbbe07._inactivityTimer = null;
          }
          const bdtv_630cb5a3f971 =
            bdtv_7d7dfa6f9df7.getRoot().classList.contains("bdt-aberto2-janela");
          if (!bdtv_630cb5a3f971) {
            bdtv_e7813df41f5c(bdtv_088f96dbbe07, "open", true);
            bdtv_088f96dbbe07.bindCouponCopy();
          } else {
            bdtv_088f96dbbe07._inactivityTriggered = false;
            bdtv_1f494ac10d1c();
          }
          bdtv_f298e568d1cc.forEach((bdtv_e57618a5e529) => {
            window.removeEventListener(bdtv_e57618a5e529, bdtv_1f494ac10d1c);
          });
        }
      }, bdtv_088f96dbbe07.delay * 1000);
    }
    bdtv_f298e568d1cc.forEach((bdtv_65047aa71f12) => {
      window.addEventListener(bdtv_65047aa71f12, bdtv_1f494ac10d1c, { passive: true });
    });
    bdtv_1f494ac10d1c();
  }

  closeHandler(bdtv_846368e1f3f8) {
    if (
      bdtv_846368e1f3f8.target.closest(".close-before") ||
      bdtv_846368e1f3f8.target.matches(".bdt-janela-veu")
    ) {
      bdtv_e7813df41f5c(this, "close");
      this.popupActive = false;
      if (bdtv_7d7dfa6f9df7.setCookie) {
        bdtv_7d7dfa6f9df7.setCookie(this.cookieName, "true", 1);
      }
    }
  }

  bindCouponCopy() {
    const bdtv_c700bedbf8b6 = this.querySelectorAll(".bdt-abate");
    bdtv_c700bedbf8b6.forEach((bdtv_c4d7d4e8df25) => {
      bdtv_c4d7d4e8df25.addEventListener("click", (bdtv_335a5c36e6be) => {
        bdtv_335a5c36e6be.preventDefault();
        navigator.clipboard.writeText(bdtv_c4d7d4e8df25.dataset.bdtPuze);
        bdtv_c4d7d4e8df25.classList.add("bdt-rine-duplicar2");
        setTimeout(() => bdtv_c4d7d4e8df25.classList.remove("bdt-rine-duplicar2"), 2000);
      });
    });
  }
}

customElements.define("bdt-antes2-bute-bifi", bdtv_83ce70e31ec0);

class bdtv_25aa5a9dbc10 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.handleShare.bind(this));
  }

  handleShare() {
    const bdtv_af164f14806d = this.getAttribute("data-bdt-titulo2") || document.title;
    const bdtv_70c21e07e59a = this.getAttribute("data-bdt-verbo") || "";
    const bdtv_afda18586b11 = this.getAttribute("data-bdt-mipo") || window.location.href;

    if (navigator.share) {
      navigator.share({ title: bdtv_af164f14806d, text: bdtv_70c21e07e59a, url: bdtv_afda18586b11 });
    }
  }
}
customElements.define("bdt-partilha-gatilho", bdtv_25aa5a9dbc10);

class bdtv_e9798c5d820f extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("button").forEach((bdtv_c6497e000172) =>
      bdtv_c6497e000172.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(bdtv_c9e07a91124d) {
    const bdtv_1c346fc274f1 = bdtv_c9e07a91124d.currentTarget;
    if (bdtv_1c346fc274f1.classList.contains("bdt-ativo2")) {
      return;
    }
    const bdtv_7435dd84dc20 = bdtv_1c346fc274f1.getAttribute("data-bdt-vopa");
    const bdtv_726de8307ff0 = document.getElementById(bdtv_7435dd84dc20);
    this.querySelectorAll("button").forEach((bdtv_d08d47a82ef7) =>
      bdtv_d08d47a82ef7.classList.remove("bdt-ativo2")
    );
    bdtv_1c346fc274f1.classList.add("bdt-ativo2");
    this.closest(".bdt-corpo-abas")
      .querySelectorAll(".bdt-aba-corpo")
      .forEach((bdtv_90cc3578982a) => {
        if (bdtv_90cc3578982a.id !== bdtv_7435dd84dc20) {
          bdtv_90cc3578982a.classList.add("bdt-oculto2");
          Motion.animate(
            bdtv_90cc3578982a,
            {
              transform: "translateY(10px)",
              opacity: 0,
              visibility: "hidden",
            },
            {
              duration: 0,
            }
          );
        }
      });

    bdtv_726de8307ff0.classList.remove("bdt-oculto2");
    Motion.animate(
      bdtv_726de8307ff0,
      {
        transform: ["translateY(10px)", "translateY(0)"],
        opacity: [0, 1],
        visibility: ["hidden", "visible"],
      },
      {
        duration: 0.5,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define("bdt-nucleo-aba", bdtv_e9798c5d820f);

class bdtv_2a754d25378c extends HTMLElement {
  constructor() {
    super();
    const bdtv_48ebb8e94b69 = document.createElement("div");
    bdtv_48ebb8e94b69.className = "progress-load-page";
    const bdtv_e94322d99f83 = document.createElement("div");
    bdtv_e94322d99f83.className = "indeterminate";
    bdtv_e94322d99f83.style.width = "0%";
    bdtv_48ebb8e94b69.appendChild(bdtv_e94322d99f83);
    this.appendChild(bdtv_48ebb8e94b69);
    this.indicator = bdtv_e94322d99f83;
    this.progress = 0;
    this.minAnimationTime = 1000;
  }

  connectedCallback() {
    window.addEventListener("beforeunload", this.complete.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("beforeunload", this.complete.bind(this));
  }

  complete() {
    this.style.display = "flex";
    this.progress = 0;
    this.isAnimating = true;
    this.indicator.style.transition = "none";
    this.indicator.style.width = "0%";
    this.indicator.style.opacity = "1";
    this.indicator.offsetWidth;
    this.indicator.style.transition = `width ${this.minAnimationTime}ms ease`;
    this.indicator.style.width = "100%";
  }
}
customElements.define("bdt-avanco-faixa2-no", bdtv_2a754d25378c);

class bdtv_b15e34c7705e extends HTMLElement {
  constructor() {
    super();
    this.percentageElement = this.querySelector(".bdt-avanco-giki");
    this.progressBar = this.querySelector(".bdt-avanco-faixa2");
    this.targetPercentage = this.percentageElement
      ? parseInt(this.percentageElement.dataset.bdtGiki)
      : 0;
  }

  connectedCallback() {
    if (this.percentageElement) {
      this.animatePercentage();
    }
  }

  animatePercentage() {
    let bdtv_cb963a707151 = 0;
    const bdtv_7aa61e730845 = () => {
      if (bdtv_cb963a707151 <= this.targetPercentage) {
        this.percentageElement.textContent = bdtv_cb963a707151 + "%";
        bdtv_cb963a707151++;
        setTimeout(bdtv_7aa61e730845.bind(this), 20);
      } else {
        this.percentageElement.textContent = this.targetPercentage + "%";
      }
    };
    setTimeout(bdtv_7aa61e730845.bind(this), 100);
  }

  resetAndAnimate() {
    if (this.percentageElement && this.progressBar) {
      this.progressBar.style.width = "0";
      this.progressBar.style.animation = "none";
      this.percentageElement.textContent = "0%";

      setTimeout(() => {
        this.progressBar.style.animation = `progressAnimation ${
          this.targetPercentage * 3
        }s ease-in-out forwards`;
        this.animatePercentage();
      }, 10);
    }
  }
}

customElements.define("bdt-avanco-faixa2-peca", bdtv_b15e34c7705e);

class bdtv_95229dafd13a extends HTMLElement {
  connectedCallback() {
    this.counterElement = this.querySelector("[data-counter-target]");
    this.circleElement = this.querySelector(".progress-ring__circle");
    this.bgCircleElement = this.querySelector(".progress-ring__bg");
    this.svgElement = this.querySelector(".bdt-avanco-la");
    this.targetValue = parseFloat(this.dataset.bdtContador2) || 100;
    this.startValue = parseFloat(this.dataset.bdtZiza) || 0;
    this.duration = parseFloat(this.dataset.bdtZabi) || 2000;
    this.isAnimated = false;

    this.setCircleAttributes();

    const bdtv_9417bb5ef42a = new IntersectionObserver(
      (bdtv_0f5d21536683) => {
        bdtv_0f5d21536683.forEach((bdtv_7bfee2c836f9) => {
          if (bdtv_7bfee2c836f9.isIntersecting) {
            this.resetAnimation();
            this.animateCounter();
          }
        });
      },
      { threshold: 0.5 }
    );
    bdtv_9417bb5ef42a.observe(this);

    this.resizeObserver = new ResizeObserver(() => {
      this.setCircleAttributes();
      if (this.isAnimated && this.circleElement && this.circumference) {
        const bdtv_06f9ca59c3de = Math.min(this.targetValue, 100) / 100;
        const bdtv_bfb150b81667 = this.circumference - bdtv_06f9ca59c3de * this.circumference;
        this.circleElement.style.strokeDashoffset = bdtv_bfb150b81667;
      }
      this.updateTextPosition();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  setCircleAttributes() {
    const bdtv_4ff0503a1ccb = getComputedStyle(this);
    const bdtv_a444a7cc651f = parseFloat(bdtv_4ff0503a1ccb.getPropertyValue("--bdt-circle-size")) || 150;
    const bdtv_5edf71dcb7a9 = parseFloat(bdtv_4ff0503a1ccb.getPropertyValue("--bdt-circle-stroke")) || 8;
    const bdtv_06071c86aae0 = bdtv_a444a7cc651f / 2 - bdtv_5edf71dcb7a9 / 2;
    const bdtv_5ebfda82fb13 = bdtv_a444a7cc651f / 2;

    if (this.svgElement) {
      this.svgElement.setAttribute("viewBox", `0 0 ${bdtv_a444a7cc651f} ${bdtv_a444a7cc651f}`);
    }

    [this.circleElement, this.bgCircleElement].forEach((bdtv_0cb08ddd6e18) => {
      if (bdtv_0cb08ddd6e18) {
        bdtv_0cb08ddd6e18.setAttribute("r", bdtv_06071c86aae0);
        bdtv_0cb08ddd6e18.setAttribute("cx", bdtv_5ebfda82fb13);
        bdtv_0cb08ddd6e18.setAttribute("cy", bdtv_5ebfda82fb13);
      }
    });

    this.radius = bdtv_06071c86aae0;
    this.circumference = 2 * Math.PI * bdtv_06071c86aae0;

    if (this.circleElement) {
      this.circleElement.style.strokeDasharray = `${this.circumference} ${this.circumference}`;
      this.circleElement.style.strokeDashoffset = this.circumference;
    }

    this.updateTextPosition();
  }

  updateTextPosition() {
    if (this.counterElement && this.circleElement) {
      const bdtv_c17d5633c3b2 = parseFloat(this.circleElement.getAttribute("cx"));
      const bdtv_b3ca78425e67 = parseFloat(this.circleElement.getAttribute("cy"));
      this.counterElement.setAttribute("x", bdtv_c17d5633c3b2);
      this.counterElement.setAttribute("y", bdtv_b3ca78425e67);
      this.counterElement.setAttribute("dominant-baseline", "middle");
      this.counterElement.removeAttribute("dy");
    }
  }

  resetAnimation() {
    this.isAnimated = false;
    this.counterElement.textContent = this.startValue;
    if (this.circleElement && this.circumference) {
      this.circleElement.style.strokeDashoffset = this.circumference;
    }
  }

  animateCounter() {
    if (this.isAnimated) return;

    let bdtv_a5280d54b861 = this.startValue;
    const bdtv_5aca78b37c0a = this.targetValue - this.startValue;
    const bdtv_2a956b3d6818 = bdtv_5aca78b37c0a / (this.duration / 16);

    const bdtv_52b5f512e317 = () => {
      bdtv_a5280d54b861 += bdtv_2a956b3d6818;
      if (bdtv_a5280d54b861 >= this.targetValue) {
        bdtv_a5280d54b861 = this.targetValue;
        this.isAnimated = true;
      }

      this.counterElement.textContent = Math.ceil(bdtv_a5280d54b861);
      const bdtv_b2b18956da83 = Math.min(bdtv_a5280d54b861, 100);
      this.style.setProperty("--bdt-progress-desktop", `${bdtv_b2b18956da83}%`);

      if (this.circleElement && this.circumference) {
        const bdtv_86a68e3e97a3 = Math.min(bdtv_a5280d54b861, 100) / 100;
        const bdtv_19ae5a1190b6 = this.circumference - bdtv_86a68e3e97a3 * this.circumference;
        this.circleElement.style.strokeDashoffset = bdtv_19ae5a1190b6;
      }

      if (bdtv_a5280d54b861 < this.targetValue) {
        requestAnimationFrame(bdtv_52b5f512e317);
      }
    };

    requestAnimationFrame(bdtv_52b5f512e317);
  }
}
customElements.define("bdt-contador2-dela", bdtv_95229dafd13a);

class bdtv_a6247179d0db extends HTMLElement {
  constructor() {
    super();
    this.tabHeadings = this.querySelectorAll(".bdt-aba-cabeca");
    this.contentDisplay = this.querySelector("#tab-content-display");

    this.activeIndex = Array.from(this.tabHeadings).findIndex((bdtv_27809dcf6c3b) =>
      bdtv_27809dcf6c3b.classList.contains("bdt-ativo2")
    );
    if (this.activeIndex === -1) {
      this.activeIndex = 0;
      this.tabHeadings[0]?.classList.add("bdt-ativo2");
    }

    if (!this.contentDisplay) {
      console.error(
        "Content display element with ID 'tab-content-display' not found within <bdt-aba-linha>."
      );
      return;
    }

    this.init();
  }

  init() {
    this.tabHeadings.forEach((bdtv_da2cbb95cc91, bdtv_4ab1e806eefe) => {
      bdtv_da2cbb95cc91.addEventListener("click", () => this.switchTab(bdtv_4ab1e806eefe));

      bdtv_da2cbb95cc91.addEventListener("keydown", (bdtv_784242e4df1e) => {
        if (bdtv_784242e4df1e.key === "Enter" || bdtv_784242e4df1e.key === " ") {
          bdtv_784242e4df1e.preventDefault();
          this.switchTab(bdtv_4ab1e806eefe);
        }
      });
    });

    if (this.tabHeadings.length > 0) {
      this._displayNewContent(
        this.activeIndex,
        this.tabHeadings[this.activeIndex],
        false
      );
    }
  }

  _getTemplateContent(bdtv_ac4b9ba38c5b) {
    const bdtv_8b4e2a428461 = document.getElementById(bdtv_ac4b9ba38c5b);
    if (bdtv_8b4e2a428461 && bdtv_8b4e2a428461.content) {
      return bdtv_8b4e2a428461.content.cloneNode(true);
    }
    return null;
  }

  switchTab(bdtv_e329b6bfa64a) {
    const bdtv_f9034c1d2c23 = this.tabHeadings[this.activeIndex];
    const bdtv_ca953d8f6df5 = this.tabHeadings[bdtv_e329b6bfa64a];

    if (bdtv_e329b6bfa64a === this.activeIndex || !bdtv_ca953d8f6df5) return;

    if (bdtv_f9034c1d2c23) {
      bdtv_f9034c1d2c23.classList.remove("bdt-ativo2");
      bdtv_f9034c1d2c23.setAttribute("aria-selected", "false");
    }

    bdtv_ca953d8f6df5.classList.add("bdt-ativo2");
    bdtv_ca953d8f6df5.setAttribute("aria-selected", "true");
    bdtv_ca953d8f6df5.focus();

    const bdtv_c60d94092a98 = this.contentDisplay.firstElementChild;

    if (bdtv_c60d94092a98 && typeof Motion !== "undefined") {
      Motion.animate(
        bdtv_c60d94092a98,
        {
          transform: "translateY(10px)",
          opacity: 0,
        },
        {
          duration: 0.2,
          easing: [0, 0, 0.3, 1],
        }
      ).finished.then(() => {
        this.contentDisplay.innerHTML = "";
        this._displayNewContent(bdtv_e329b6bfa64a, bdtv_ca953d8f6df5, true);
      });
    } else {
      this.contentDisplay.innerHTML = "";
      this._displayNewContent(bdtv_e329b6bfa64a, bdtv_ca953d8f6df5, true);
    }
  }

  _displayNewContent(bdtv_f1d800329747, bdtv_59a5bec11186, bdtv_10a7b6f5c9ac = true) {
    const bdtv_23162b2acfee = bdtv_59a5bec11186.dataset.bdtKagiCorpoVopa;
    const bdtv_d6912a9a67f8 = this._getTemplateContent(bdtv_23162b2acfee);

    this.activeIndex = bdtv_f1d800329747;

    if (bdtv_d6912a9a67f8) {
      this.contentDisplay.appendChild(bdtv_d6912a9a67f8);

      if (bdtv_10a7b6f5c9ac && typeof Motion !== "undefined") {
        Motion.animate(
          bdtv_d6912a9a67f8,
          {
            transform: ["translateY(10px)", "translateY(0)"],
            opacity: [0, 1],
          },
          {
            duration: 0.2,
            delay: 0,
            easing: [0, 0, 0.3, 1],
          }
        );
      }
    }
  }
}

customElements.define("bdt-aba-linha", bdtv_a6247179d0db);

class bdtv_b3f30fbb9293 extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.bdtFaixaVopa;
    this.modal = this.querySelector("bdt-abate-janela-balao");
    window.Shopify.designMode &&
      (document.addEventListener("shopify:section:select", (bdtv_6a4e1f9fa229) => {
        const bdtv_755283103f42 = bdtv_6a4e1f9fa229.target;
        if (
          JSON.parse(bdtv_755283103f42.dataset.shopifyEditorSection).id ===
          this.sectionId
        ) {
          bdtv_e7813df41f5c(this.modal, "open", false);
        }
      }),
      document.addEventListener("shopify:section:deselect", () => {
        if (this.modal) {
          bdtv_e7813df41f5c(this.modal, "close", false);
        }
      }));
  }
}

customElements.define("bdt-abate-balao", bdtv_b3f30fbb9293);
